import { createApi } from '@bloobirds-it/plover';
import { BobjectTypes, TASK_FIELDS_LOGIC_ROLE, OPPORTUNITY_FIELDS_LOGIC_ROLE, LEAD_FIELDS_LOGIC_ROLE, COMPANY_FIELDS_LOGIC_ROLE, LEAD_STAGE_LOGIC_ROLE, COMPANY_STAGE_LOGIC_ROLE, PluralBobjectTypes, BOBJECT_TYPES, APP_CL_COMPANIES, APP_CL_LEADS, FIELDS_LOGIC_ROLE, TASK_STATUS_VALUE_LOGIC_ROLE, TASK_TYPE, TASK_AUTOMATED_VALUE, TASK_ACTION, TASK_ACTION_VALUE, ACTIVITY_FIELDS_LOGIC_ROLE, PlaybookTab } from '@bloobirds-it/types';
import groupBy from 'lodash/groupBy';
import useSWR from 'swr';
import { format, subDays, addDays, differenceInDays, getWeeksInMonth as getWeeksInMonth$1, getDay, isSameDay as isSameDay$1, isAfter, startOfDay, isWeekend as isWeekend$1, eachDayOfInterval, startOfMonth, endOfMonth, startOfWeek, isBefore, endOfWeek, addMonths, addMinutes as addMinutes$1, subMinutes as subMinutes$1, subMonths, formatDistance as formatDistance$1, formatDistanceToNow as formatDistanceToNow$1, addSeconds, isYesterday, differenceInCalendarDays, addHours, getDate, isValid, parse } from 'date-fns';
export { addDays, differenceInDays, endOfDay, getDaysInMonth, startOfDay, subDays } from 'date-fns';
import spacetime from 'spacetime';
import lookup from 'country-code-lookup';
import { camelCase, startCase, lowerCase, isUndefined, pickBy, assign } from 'lodash';
import { useRef, useEffect, useCallback } from 'react';
import normalize from 'normalize-url';

function parseAmount(amount) {
  var maxDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var minDecimals = arguments.length > 2 ? arguments[2] : undefined;
  if (!amount && amount !== 0) {
    console.error('Trying to parse an undefined amount');
    return undefined; //throw new Error('Trying to parse an undefined');
  }

  var parsedAmount = Number(amount);
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDecimals !== null && minDecimals !== void 0 ? minDecimals : maxDecimals,
    maximumFractionDigits: !minDecimals || maxDecimals > minDecimals ? maxDecimals : minDecimals
  }).format(parsedAmount);
}
function shortenAmount(amount) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var space = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!amount && amount !== 0) {
    console.error('Trying to shorten an undefined amount');
    return undefined; //throw new Error('Trying to shorten amount of undefined');
  }

  var parsedAmount = Number(amount);
  // Don't shorten if amount is less than 10k
  if (parsedAmount < 10000) {
    return parseAmount(parsedAmount, parsedAmount < 1000 ? decimals < 3 ? decimals : 2 : 0, 0);
  }

  // format
  var formattedAmount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: parsedAmount < Math.pow(10, 15) ? parsedAmount < Math.pow(10, 6) && parsedAmount % 100 / parsedAmount < 0.001 ? 2 : decimals : 0,
    notation: 'compact'
  }).format(parsedAmount);

  // Add comma to numbers in a thousand trillion range (15 and 16 digits)
  if (parsedAmount >= Math.pow(10, 15) && parsedAmount < Math.pow(10, 17)) {
    formattedAmount = parseAmount(formattedAmount.replace('T', ''), decimals).concat('T');
  }

  // Add space between number and unit
  if (space) {
    return formattedAmount.substring(0, formattedAmount.length - 1).concat(' ').concat(formattedAmount.substring(formattedAmount.length - 1));
  } else return formattedAmount;
}

var appHostnames = ['app.dev-bloobirds.com', 'app.bloobirds.com', 'localhost'];

//@ts-ignore
var api = createApi({
  getToken: function getToken() {
    if (appHostnames.includes(window.location.hostname) || window.location.hostname.includes('bloobirds-platform-frontend.pages.dev')) {
      var session = localStorage.getItem('bb-app-session');
      if (session) {
        var _JSON$parse;
        return ((_JSON$parse = JSON.parse(session)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.token) || null;
      }
      return null;
    } else {
      if (chrome) {
        return new Promise(function (resolve) {
          chrome.storage.sync.get({
            token: ''
          }, function (_ref) {
            var token = _ref.token;
            resolve(token);
          });
        });
      }
    }
  },
  getEnvironment: function getEnvironment() {
    return process.env.ENV || 'local';
  }
});

// TODO: Move this out of here and directly into the parser
var MessagesEvents = {
  UrlNotFound: 'MESSAGES_EVENTS_URL_NOT_FOUND',
  UrlFound: 'MESSAGES_EVENTS_URL_FOUND',
  ForceOpenExtension: 'FORCE_OPEN_EXTENSION',
  UserLoggedIn: 'USER_LOGGED_IN',
  UserLoggedOut: 'USER_LOGGED_OUT',
  PlaybookFeed: 'PLAYBOOK_FEED'
};

function _typeof$4(obj) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$4(obj); }
function _regeneratorRuntime$3() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$3 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$4(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$3(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function isLoggedIn() {
  return _isLoggedIn.apply(this, arguments);
}
function _isLoggedIn() {
  _isLoggedIn = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee() {
    return _regeneratorRuntime$3().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              var _chrome3, _chrome3$storage, _chrome3$storage$sync;
              (_chrome3 = chrome) === null || _chrome3 === void 0 ? void 0 : (_chrome3$storage = _chrome3.storage) === null || _chrome3$storage === void 0 ? void 0 : (_chrome3$storage$sync = _chrome3$storage.sync) === null || _chrome3$storage$sync === void 0 ? void 0 : _chrome3$storage$sync.get({
                token: ''
              }, function (items) {
                resolve(!!items.token);
              });
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _isLoggedIn.apply(this, arguments);
}
function login(_x) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee2(_ref) {
    var _chrome4, _chrome4$storage, _chrome4$storage$sync;
    var email, password, _yield$api$post, token;
    return _regeneratorRuntime$3().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            email = _ref.email, password = _ref.password;
            _context2.next = 3;
            return api.post('/auth/service/jwt', {
              email: email,
              password: password,
              claimerSystem: 'linkedin_ce'
            });
          case 3:
            _yield$api$post = _context2.sent;
            token = _yield$api$post.data.token;
            (_chrome4 = chrome) === null || _chrome4 === void 0 ? void 0 : (_chrome4$storage = _chrome4.storage) === null || _chrome4$storage === void 0 ? void 0 : (_chrome4$storage$sync = _chrome4$storage.sync) === null || _chrome4$storage$sync === void 0 ? void 0 : _chrome4$storage$sync.set({
              token: token
            });
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _login.apply(this, arguments);
}
function logout() {
  return new Promise(function (resolve) {
    var _chrome, _chrome$storage, _chrome$storage$sync;
    (_chrome = chrome) === null || _chrome === void 0 ? void 0 : (_chrome$storage = _chrome.storage) === null || _chrome$storage === void 0 ? void 0 : (_chrome$storage$sync = _chrome$storage.sync) === null || _chrome$storage$sync === void 0 ? void 0 : _chrome$storage$sync.set({
      token: ''
    }, function () {
      // @ts-ignore
      resolve();
      window.dispatchEvent(new CustomEvent(MessagesEvents.UserLoggedOut));
    });
  });
}
function getToken() {
  return new Promise(function (resolve) {
    var _chrome2, _chrome2$storage, _chrome2$storage$sync;
    (_chrome2 = chrome) === null || _chrome2 === void 0 ? void 0 : (_chrome2$storage = _chrome2.storage) === null || _chrome2$storage === void 0 ? void 0 : (_chrome2$storage$sync = _chrome2$storage.sync) === null || _chrome2$storage$sync === void 0 ? void 0 : _chrome2$storage$sync.get({
      token: ''
    }, function (_ref2) {
      var token = _ref2.token;
      if (token) {
        var contents = JSON.parse(atob(token.split('.')[1]));
        resolve(contents);
      } else {
        resolve(null);
      }
    });
  });
}
function getTokenEncoded() {
  return _getTokenEncoded.apply(this, arguments);
}
function _getTokenEncoded() {
  _getTokenEncoded = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee3() {
    return _regeneratorRuntime$3().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return new Promise(function (resolve) {
              var _chrome5, _chrome5$storage, _chrome5$storage$sync;
              (_chrome5 = chrome) === null || _chrome5 === void 0 ? void 0 : (_chrome5$storage = _chrome5.storage) === null || _chrome5$storage === void 0 ? void 0 : (_chrome5$storage$sync = _chrome5$storage.sync) === null || _chrome5$storage$sync === void 0 ? void 0 : _chrome5$storage$sync.get({
                token: ''
              }, function (_ref3) {
                var token = _ref3.token;
                if (token) {
                  resolve(token);
                } else {
                  resolve(null);
                }
              });
            });
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getTokenEncoded.apply(this, arguments);
}
function getAccountId() {
  return _getAccountId.apply(this, arguments);
}
function _getAccountId() {
  _getAccountId = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee4() {
    var token;
    return _regeneratorRuntime$3().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getToken();
          case 2:
            token = _context4.sent;
            return _context4.abrupt("return", token === null || token === void 0 ? void 0 : token.account);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getAccountId.apply(this, arguments);
}
function getUserId() {
  return _getUserId.apply(this, arguments);
}
function _getUserId() {
  _getUserId = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee5() {
    var session, _JSON$parse, _JSON$parse$context, _JSON$parse$context$u, token;
    return _regeneratorRuntime$3().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(appHostnames.includes(window.location.hostname) || window.location.hostname.includes('bloobirds-platform-frontend.pages.dev'))) {
              _context5.next = 7;
              break;
            }
            session = localStorage.getItem('bb-app-session');
            if (!session) {
              _context5.next = 4;
              break;
            }
            return _context5.abrupt("return", ((_JSON$parse = JSON.parse(session)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$context = _JSON$parse.context) === null || _JSON$parse$context === void 0 ? void 0 : (_JSON$parse$context$u = _JSON$parse$context.user) === null || _JSON$parse$context$u === void 0 ? void 0 : _JSON$parse$context$u.id) || null);
          case 4:
            return _context5.abrupt("return", null);
          case 7:
            _context5.next = 9;
            return getToken();
          case 9:
            token = _context5.sent;
            return _context5.abrupt("return", token === null || token === void 0 ? void 0 : token.sub);
          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getUserId.apply(this, arguments);
}
function getUserName() {
  return _getUserName.apply(this, arguments);
}
function _getUserName() {
  _getUserName = _asyncToGenerator$3( /*#__PURE__*/_regeneratorRuntime$3().mark(function _callee6() {
    var token;
    return _regeneratorRuntime$3().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getToken();
          case 2:
            token = _context6.sent;
            return _context6.abrupt("return", token.userName);
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getUserName.apply(this, arguments);
}

function _typeof$3(obj) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$3(obj); }
function _regeneratorRuntime$2() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$2 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$3(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$2(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var findByProperties = function findByProperties(bobjectFields, properties, value) {
  for (var i = 0; i < properties.length; i += 1) {
    var field = findByProperty(bobjectFields, properties[i], value);
    if (field !== undefined) {
      return field;
    }
  }
  return undefined;
};
var getNameFieldLRFromBobjectType = function getNameFieldLRFromBobjectType(bobjectType) {
  switch (bobjectType) {
    case BobjectTypes.Company:
      return COMPANY_FIELDS_LOGIC_ROLE.NAME;
    case BobjectTypes.Lead:
      return LEAD_FIELDS_LOGIC_ROLE.FULL_NAME;
    case BobjectTypes.Opportunity:
      return OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME;
    case BobjectTypes.Task:
      return TASK_FIELDS_LOGIC_ROLE.TITLE;
  }
};
var groupFieldsByGroup = function groupFieldsByGroup(bobjectFields) {
  var groupMetadata = {};
  bobjectFields.filter(function (bf) {
    return bf.groupName !== null && bf.groupName !== undefined;
  }).forEach(function (bf) {
    groupMetadata[bf.groupName] = {
      name: bf.groupName,
      ordering: bf.groupOrdering,
      detailDisplay: bf.groupDetailDisplay
    };
  });
  var groups = Object.keys(groupMetadata);
  var fieldsByGroup = {};
  groups.forEach(function (group) {
    fieldsByGroup[group] = [];
  });
  bobjectFields.filter(function (bf) {
    return bf.groupName !== null && bf.groupName !== undefined;
  }).forEach(function (bf) {
    if (bf.logicRole !== 'COMPANY__NAME') {
      fieldsByGroup[bf.groupName].push(bf);
    }
  });
  Object.values(fieldsByGroup).forEach(function (fields) {
    return fields.sort(function (f1, f2) {
      return (f1 === null || f1 === void 0 ? void 0 : f1.ordering) - (f2 === null || f2 === void 0 ? void 0 : f2.ordering);
    });
  });
  var arranged = [];
  Object.keys(fieldsByGroup).forEach(function (groupName) {
    return arranged.push({
      name: groupName.toUpperCase(),
      fields: fieldsByGroup[groupName],
      meta: groupMetadata[groupName]
    });
  });
  arranged.sort(function (f1, f2) {
    return f1.fields[0].groupOrdering - f2.fields[0].groupOrdering;
  });
  return arranged;
};
var findByProperty = function findByProperty(bobjectFields, property, value) {
  var matchingFields = bobjectFields.filter(function (b) {
    return b[property] === value;
  });
  if (matchingFields.length === 1) {
    return matchingFields[0];
  }
  if (matchingFields.length === 0) {
    return undefined;
  }
  return matchingFields;
};
var bobjectFieldsModel = function bobjectFieldsModel(bobjectFields) {
  return {
    find: function find(fieldDescriptor) {
      return findByProperties(bobjectFields, ['id', 'name', 'logicRole'], fieldDescriptor);
    },
    findById: function findById(bobjectFieldId) {
      return findByProperty(bobjectFields, 'name', bobjectFieldId);
    },
    findByLogicRole: function findByLogicRole(logicRole) {
      return findByProperty(bobjectFields, 'logicRole', logicRole);
    },
    findByLabel: function findByLabel(label) {
      return findByProperty(bobjectFields, 'label', label);
    },
    groupFieldsByGroup: groupFieldsByGroup,
    findByCondition: function findByCondition(condition) {
      return bobjectFields.filter(condition);
    },
    findBy: function findBy(property) {
      return function (value) {
        return findByProperty(bobjectFields, property, value);
      };
    }
  };
};
var findByPropertiesAndValues = function findByPropertiesAndValues(bobjectFields, properties, values) {
  for (var i = 0; i < values.length; i += 1) {
    var field = findByProperties(bobjectFields, properties, values[i]);
    if (field !== undefined) {
      return field;
    }
  }
  return undefined;
};
var bobjectModel = function bobjectModel(bobject) {
  var bobjectFields = bobject.fields;
  var bobjectPrefix = "".concat(bobject.id.typeName.toUpperCase(), "__");
  var model = bobjectFieldsModel(bobjectFields);
  model.find = function (fieldDescriptor) {
    return findByPropertiesAndValues(bobjectFields, ['id', 'name', 'logicRole'], [fieldDescriptor, bobjectPrefix + fieldDescriptor]);
  };
  model['type'] = function () {
    return bobject.id.typeName;
  };
  return model;
};
var getRelatedBobject = function getRelatedBobject(bobject, relatedBobjectType) {
  var _model$findBy;
  var model = bobjectModel(bobject);
  return (_model$findBy = model.findBy('referencedBobjectType')(relatedBobjectType)) === null || _model$findBy === void 0 ? void 0 : _model$findBy.referencedBobject;
};
var getFieldByLogicRole = function getFieldByLogicRole(bobject, logicRole) {
  if (bobject !== null && bobject !== void 0 && bobject.fields) {
    return bobject === null || bobject === void 0 ? void 0 : bobject.fields.find(function (fieldItem) {
      return fieldItem.logicRole === logicRole;
    });
  }
  return null;
};
var getReferencedBobjectFromLogicRole = function getReferencedBobjectFromLogicRole(bobject, logicRole) {
  var field = getFieldByLogicRole(bobject, logicRole);
  return field === null || field === void 0 ? void 0 : field.referencedBobject;
};
var getValueFromLogicRole = function getValueFromLogicRole(bobject, logicRole) {
  var asText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var field = getFieldByLogicRole(bobject, logicRole);
  return asText ? field === null || field === void 0 ? void 0 : field.text : field === null || field === void 0 ? void 0 : field.value;
};
var getTextFromLogicRole = function getTextFromLogicRole(bobject, logicRole) {
  return getValueFromLogicRole(bobject, logicRole, true);
};
var getFieldsByType = function getFieldsByType(bobject, fieldType) {
  var _bobject$fields;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$fields = bobject.fields) === null || _bobject$fields === void 0 ? void 0 : _bobject$fields.filter(function (fieldItem) {
    return (fieldItem === null || fieldItem === void 0 ? void 0 : fieldItem.type) === fieldType;
  })) || [];
};
var getFieldsByIds = function getFieldsByIds(bobject, ids) {
  var _bobject$fields2;
  return bobject === null || bobject === void 0 ? void 0 : (_bobject$fields2 = bobject.fields) === null || _bobject$fields2 === void 0 ? void 0 : _bobject$fields2.filter(function (field) {
    return ids.includes(field.name);
  });
};
var getFieldById = function getFieldById(bobject, id) {
  return bobject === null || bobject === void 0 ? void 0 : bobject.fields.find(function (fieldItem) {
    return fieldItem.name === id;
  });
};
var getFieldTextById = function getFieldTextById(bobject, id) {
  var _getFieldById;
  return (_getFieldById = getFieldById(bobject, id)) === null || _getFieldById === void 0 ? void 0 : _getFieldById.text;
};
var checkIsSalesBobject = function checkIsSalesBobject(bobject) {
  switch (bobject.id.typeName) {
    case BobjectTypes.Company:
      return getFieldByLogicRole(bobject, COMPANY_FIELDS_LOGIC_ROLE.STAGE).valueLogicRole === COMPANY_STAGE_LOGIC_ROLE.SALES;
    case BobjectTypes.Lead:
      return getFieldByLogicRole(bobject, LEAD_FIELDS_LOGIC_ROLE.STAGE).valueLogicRole === LEAD_STAGE_LOGIC_ROLE.SALES;
    default:
      return false;
  }
};
var getBobjectFromLogicRole = function getBobjectFromLogicRole(logicRole) {
  var companyRegex = /COMPANY__*/;
  var leadRegex = /LEAD__*/;
  var opportunityRegex = /OPPORTUNITY__*/;
  var taskRegex = /TASK__*/;
  var activityRegex = /ACTIVITY__*/;
  if (companyRegex.test(logicRole)) return BobjectTypes.Company;
  if (leadRegex.test(logicRole)) return BobjectTypes.Lead;
  if (opportunityRegex.test(logicRole)) return BobjectTypes.Opportunity;
  if (taskRegex.test(logicRole)) return BobjectTypes.Task;
  if (activityRegex.test(logicRole)) return BobjectTypes.Activity;
};
var processInjectField = function processInjectField(response, field) {
  var referencedBobject;
  if (field.type === 'REFERENCE') {
    if (field.referencedBobjectType !== undefined && field.referencedBobjectType !== null && field.text !== null && field.text !== undefined && response.referencedBobjects !== undefined && response.referencedBobjects !== null) {
      referencedBobject = response.referencedBobjects[field.text];
    }
  }
  return _objectSpread$4(_objectSpread$4({}, field), {}, {
    referencedBobject: referencedBobject
  });
};
var injectReferencesSearchProcess = function injectReferencesSearchProcess(response) {
  var extendedContents = response.contents.map(function (bobject) {
    var extendedFields = bobject.fields.map(function (field) {
      return processInjectField(response, field);
    });
    return _objectSpread$4(_objectSpread$4({}, bobject), {}, {
      fields: extendedFields
    });
  });
  return _objectSpread$4(_objectSpread$4({}, response), {}, {
    contents: extendedContents
  });
};
var tabBobjectType = function tabBobjectType(section) {
  switch (section) {
    case PluralBobjectTypes.Lead:
      return BobjectTypes.Lead;
    case PluralBobjectTypes.Opportunity:
      return BobjectTypes.Opportunity;
    default:
      return BobjectTypes.Company;
  }
};
var getBobjectTypeFromPathname = function getBobjectTypeFromPathname(pathname) {
  if (pathname.includes(PluralBobjectTypes.Lead.toLowerCase())) {
    return BobjectTypes.Lead;
  } else if (pathname.includes(PluralBobjectTypes.Opportunity.toLowerCase())) {
    return BobjectTypes.Opportunity;
  } else {
    return BobjectTypes.Company;
  }
};
var isOpportunity = function isOpportunity(bobject) {
  var _bobject$id;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$id = bobject.id) === null || _bobject$id === void 0 ? void 0 : _bobject$id.typeName) === BOBJECT_TYPES.OPPORTUNITY;
};
var isLead = function isLead(bobject) {
  var _bobject$id2;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$id2 = bobject.id) === null || _bobject$id2 === void 0 ? void 0 : _bobject$id2.typeName) === BOBJECT_TYPES.LEAD;
};
var isCompany = function isCompany(bobject) {
  var _bobject$id3;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$id3 = bobject.id) === null || _bobject$id3 === void 0 ? void 0 : _bobject$id3.typeName) === BOBJECT_TYPES.COMPANY;
};
var isTask = function isTask(bobject) {
  var _bobject$id4;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$id4 = bobject.id) === null || _bobject$id4 === void 0 ? void 0 : _bobject$id4.typeName) === BOBJECT_TYPES.TASK;
};
var isActivity = function isActivity(bobject) {
  var _bobject$id5;
  return (bobject === null || bobject === void 0 ? void 0 : (_bobject$id5 = bobject.id) === null || _bobject$id5 === void 0 ? void 0 : _bobject$id5.typeName) === BOBJECT_TYPES.ACTIVITY;
};
var hasRequiredMissing = function hasRequiredMissing(_ref) {
  var _bobjectTypes$findBy, _bobjectFields$filter;
  var bobjectType = _ref.bobjectType,
    bobjectFields = _ref.bobjectFields,
    bobjectTypes = _ref.bobjectTypes,
    bobject = _ref.bobject,
    bobjectConditionalFields = _ref.bobjectConditionalFields;
  var bobjectTypeId = bobjectTypes === null || bobjectTypes === void 0 ? void 0 : (_bobjectTypes$findBy = bobjectTypes.findBy('name')(bobjectType)) === null || _bobjectTypes$findBy === void 0 ? void 0 : _bobjectTypes$findBy.id;
  var requiredFields = (bobjectFields === null || bobjectFields === void 0 ? void 0 : (_bobjectFields$filter = bobjectFields.filterBy('bobjectType', bobjectTypeId)) === null || _bobjectFields$filter === void 0 ? void 0 : _bobjectFields$filter.filter(function (field) {
    return field.required && !!(field !== null && field !== void 0 && field.bobjectFieldGroup) && !(field !== null && field !== void 0 && field.layoutReadOnly);
  })) || [];
  if (!requiredFields || requiredFields.length === 0) {
    return false;
  }
  var requiredFieldsId = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.map(function (field) {
    return field.id;
  });
  var values = getFieldsByIds(bobject, requiredFieldsId);
  var conditions = groupBy(bobjectConditionalFields === null || bobjectConditionalFields === void 0 ? void 0 : bobjectConditionalFields.all(), 'bobjectField');
  var valuesWithoutConditions = values === null || values === void 0 ? void 0 : values.filter(function (value) {
    return !conditions[value.name] || conditions[value.name].some(function (condition) {
      return Object.values(bobject.raw.contents).includes(condition.requiredType);
    });
  });
  return valuesWithoutConditions === null || valuesWithoutConditions === void 0 ? void 0 : valuesWithoutConditions.some(function (value) {
    return !value.value;
  });
};
var companyUrl = function companyUrl(company) {
  if (company) {
    return "".concat(APP_CL_COMPANIES, "/").concat(company.id.objectId);
  }
  return APP_CL_COMPANIES;
};
var leadUrl = function leadUrl(lead, company) {
  var _company$id, _lead3, _lead3$id;
  if (typeof lead === 'string') {
    var _lead;
    if (((_lead = lead) === null || _lead === void 0 ? void 0 : _lead.indexOf('/')) > 0) {
      lead = lead.split('/')[2];
    }
    return "".concat(APP_CL_LEADS, "/").concat(lead);
  }
  if (company !== null && company !== void 0 && (_company$id = company.id) !== null && _company$id !== void 0 && _company$id.objectId) {
    var _company$id2, _lead2, _lead2$id;
    return "".concat(APP_CL_COMPANIES, "/").concat(company === null || company === void 0 ? void 0 : (_company$id2 = company.id) === null || _company$id2 === void 0 ? void 0 : _company$id2.objectId, "?leadId=").concat((_lead2 = lead) === null || _lead2 === void 0 ? void 0 : (_lead2$id = _lead2.id) === null || _lead2$id === void 0 ? void 0 : _lead2$id.value);
  }
  return "".concat(APP_CL_LEADS, "/").concat((_lead3 = lead) === null || _lead3 === void 0 ? void 0 : (_lead3$id = _lead3.id) === null || _lead3$id === void 0 ? void 0 : _lead3$id.objectId);
};
var getReferencedBobject = function getReferencedBobject(bobject) {
  var _bobject$id6, _getFieldByLogicRole, _FIELDS_LOGIC_ROLE, _getFieldByLogicRole2, _FIELDS_LOGIC_ROLE2, _getFieldByLogicRole3, _FIELDS_LOGIC_ROLE3;
  var bobjectType = bobject === null || bobject === void 0 ? void 0 : (_bobject$id6 = bobject.id) === null || _bobject$id6 === void 0 ? void 0 : _bobject$id6.typeName;
  var relatedCompany = (_getFieldByLogicRole = getFieldByLogicRole(bobject, (_FIELDS_LOGIC_ROLE = FIELDS_LOGIC_ROLE[bobjectType]) === null || _FIELDS_LOGIC_ROLE === void 0 ? void 0 : _FIELDS_LOGIC_ROLE.COMPANY)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.referencedBobject;
  var relatedLead = (_getFieldByLogicRole2 = getFieldByLogicRole(bobject, (_FIELDS_LOGIC_ROLE2 = FIELDS_LOGIC_ROLE[bobjectType]) === null || _FIELDS_LOGIC_ROLE2 === void 0 ? void 0 : _FIELDS_LOGIC_ROLE2.LEAD)) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.referencedBobject;
  var relatedOpportunity = (_getFieldByLogicRole3 = getFieldByLogicRole(bobject, (_FIELDS_LOGIC_ROLE3 = FIELDS_LOGIC_ROLE[bobjectType]) === null || _FIELDS_LOGIC_ROLE3 === void 0 ? void 0 : _FIELDS_LOGIC_ROLE3.OPPORTUNITY)) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.referencedBobject;
  var getMainBobject = function getMainBobject() {
    if (relatedOpportunity) return relatedOpportunity;
    if (relatedLead) return relatedLead;
    if (relatedCompany) return relatedCompany;
  };
  var mainBobject = getMainBobject();
  return mainBobject ? mainBobject : bobject;
};
function getStageField(dataModel, bobjectType) {
  if (!dataModel || !bobjectType) {
    return undefined;
  }
  var fieldsByBobjectType = dataModel.getFieldsByBobjectType(bobjectType);
  if (!fieldsByBobjectType) return undefined;
  return fieldsByBobjectType === null || fieldsByBobjectType === void 0 ? void 0 : fieldsByBobjectType.find(function (_ref2) {
    var name = _ref2.name;
    return name.includes('Stage');
  });
}

/** Returns whether a bobject is in sales or not. Needs DataModel when bobject
 * is an ExtensionBobject. If you are sure bobject is of type Bobject, you can pass
 * dataModel as undefined.
 *
 * @param dataModel DataModelResponse type
 * @param bobject Accepts both Bobject and ExtensionBobject types
 */
function getIsSales(dataModel, bobject) {
  var _bobject$id$typeName, _bobject$id7;
  var bobjectType = (_bobject$id$typeName = bobject === null || bobject === void 0 ? void 0 : (_bobject$id7 = bobject.id) === null || _bobject$id7 === void 0 ? void 0 : _bobject$id7.typeName) !== null && _bobject$id$typeName !== void 0 ? _bobject$id$typeName : bobject.bobjectType;
  if (!bobjectType) return undefined;
  if (bobjectType === 'Opportunity') return true;
  if (bobject !== null && bobject !== void 0 && bobject.rawBobject) {
    var _dataModel$findValueB;
    // bobject is ExtensionBobject
    var stageField = dataModel && getStageField(dataModel, bobjectType);
    var stage = bobject === null || bobject === void 0 ? void 0 : bobject.rawBobject[stageField === null || stageField === void 0 ? void 0 : stageField.id];
    return ((_dataModel$findValueB = dataModel.findValueById(stage)) === null || _dataModel$findValueB === void 0 ? void 0 : _dataModel$findValueB.name) === 'Sales';
  } else {
    // bobject is Bobject
    return getTextFromLogicRole(bobject, FIELDS_LOGIC_ROLE[bobjectType].STAGE) === 'Sales';
  }
}
var bobjectPlurals = {
  Activity: 'Activities',
  Company: 'Companies',
  Lead: 'Leads',
  Meeting: 'Meetings',
  Task: 'Tasks',
  Opportunity: 'Opportunities',
  Product: 'Products',
  OpportunityProduct: 'Opportunity Products'
};
var getPluralBobjectName = function getPluralBobjectName(bobjectName, number) {
  if (number > 1) {
    return bobjectPlurals[bobjectName];
  }
  return bobjectName;
};
var getRelatedBobjectTypeName = function getRelatedBobjectTypeName(bobject) {
  var typeName = bobject === null || bobject === void 0 ? void 0 : bobject.id.typeName;
  if (BOBJECT_TYPES.ACTIVITY === typeName || BOBJECT_TYPES.TASK === typeName) {
    var _FIELDS_LOGIC_ROLE$ty, _FIELDS_LOGIC_ROLE$ty2;
    var bobjectLead = getValueFromLogicRole(bobject, (_FIELDS_LOGIC_ROLE$ty = FIELDS_LOGIC_ROLE[typeName]) === null || _FIELDS_LOGIC_ROLE$ty === void 0 ? void 0 : _FIELDS_LOGIC_ROLE$ty.LEAD);
    var bobjectOpportunity = getValueFromLogicRole(bobject, (_FIELDS_LOGIC_ROLE$ty2 = FIELDS_LOGIC_ROLE[typeName]) === null || _FIELDS_LOGIC_ROLE$ty2 === void 0 ? void 0 : _FIELDS_LOGIC_ROLE$ty2.OPPORTUNITY);
    typeName = BOBJECT_TYPES.COMPANY;
    if (bobjectLead) {
      typeName = BOBJECT_TYPES.LEAD;
    }
    if (bobjectOpportunity) {
      typeName = BOBJECT_TYPES.OPPORTUNITY;
    }
  }
  return typeName;
};
function getExtensionBobjectByIdFields(bobjectIdFields) {
  var _PluralBobjectTypes$b;
  return api.get("/linkedin/".concat((_PluralBobjectTypes$b = PluralBobjectTypes[bobjectIdFields === null || bobjectIdFields === void 0 ? void 0 : bobjectIdFields.typeName]) === null || _PluralBobjectTypes$b === void 0 ? void 0 : _PluralBobjectTypes$b.toLowerCase(), "/").concat(bobjectIdFields === null || bobjectIdFields === void 0 ? void 0 : bobjectIdFields.objectId));
}
function getLeadById(leadId, accountId) {
  var _useSWR = useSWR("/Lead/".concat(leadId, "/form"), /*#__PURE__*/_asyncToGenerator$2( /*#__PURE__*/_regeneratorRuntime$2().mark(function _callee() {
      return _regeneratorRuntime$2().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", api.get("/bobjects/".concat(accountId, "/Lead/").concat(leadId, "/form")).then(function (_ref4) {
                var data = _ref4.data;
                return injectReferencesSearchProcess(data === null || data === void 0 ? void 0 : data.data);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))),
    lead = _useSWR.data;
  return {
    lead: lead
  };
}
function getOpportunityById(opportunityId, accountId) {
  var _useSWR2 = useSWR("/Opportunity/".concat(opportunityId, "/form"), /*#__PURE__*/_asyncToGenerator$2( /*#__PURE__*/_regeneratorRuntime$2().mark(function _callee2() {
      return _regeneratorRuntime$2().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", api.get("/bobjects/".concat(accountId, "/Opportunity/").concat(opportunityId, "/form")).then(function (_ref6) {
                var data = _ref6.data;
                return injectReferencesSearchProcess(data === null || data === void 0 ? void 0 : data.data);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))),
    opportunity = _useSWR2.data;
  return {
    opportunity: opportunity
  };
}

/**
 * Composed lead Id
 * @param leadId
 */
function convertLeadInBloobirds(_x) {
  return _convertLeadInBloobirds.apply(this, arguments);
}
function _convertLeadInBloobirds() {
  _convertLeadInBloobirds = _asyncToGenerator$2( /*#__PURE__*/_regeneratorRuntime$2().mark(function _callee3(leadId) {
    return _regeneratorRuntime$2().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return api.put("/bobjects/".concat(leadId, "/convert"), {
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              data: {}
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _convertLeadInBloobirds.apply(this, arguments);
}

// eslint-disable-next-line prettier/prettier

/**
 * @deprecated use getISOShortFormattedDate instead
 */
var getSimpleDate = function getSimpleDate(date) {
  if (!date) {
    throw new Error('Date parameter is required');
  }
  return format(date, 'yyyy-LL-dd');
};
var getDateRange = function getDateRange(_ref) {
  var startingDate = _ref.startingDate,
    _ref$pastRange = _ref.pastRange,
    pastRange = _ref$pastRange === void 0 ? 15 : _ref$pastRange,
    _ref$futureRange = _ref.futureRange,
    futureRange = _ref$futureRange === void 0 ? 3 : _ref$futureRange,
    _ref$includeToday = _ref.includeToday,
    includeToday = _ref$includeToday === void 0 ? true : _ref$includeToday;
  var pastDays = Array.from({
    length: pastRange
  }, function (v, k) {
    return k + 1;
  }).map(function (i) {
    return subDays(startingDate, i);
  });
  var thisDay = includeToday ? [startingDate] : [];
  var futureDays = Array.from({
    length: futureRange
  }, function (v, k) {
    return k + 1;
  }).map(function (i) {
    return addDays(startingDate, i);
  });
  return pastDays.concat(thisDay, futureDays).map(function (d) {
    return getSimpleDate(d);
  });
};
var getRangeBetweenDates = function getRangeBetweenDates(startDate, endDate) {
  var formatPattern = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'yyyy-MM-dd';
  var days = differenceInDays(new Date(endDate), new Date(startDate));
  return Array(days + 1).map(function (x, i) {
    return format(addDays(new Date(startDate), i), formatPattern);
  });
};
var getWeeksInMonth = function getWeeksInMonth(date, dirtyOptions) {
  return getWeeksInMonth$1(date, dirtyOptions);
};
var getTimeZoneLocationPosition = function getTimeZoneLocationPosition(completeTimeZone) {
  return completeTimeZone.split(' ', 3).join(' ').length;
};
var getWeekOfMonth = function getWeekOfMonth(date, dirtyOptions) {
  var options = dirtyOptions || {};
  var weekStartsOn = options.weekStartsOn == null ? 0 : options.weekStartsOn;

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var currentDayOfMonth = getDate(date);
  if (Number.isNaN(currentDayOfMonth)) {
    return currentDayOfMonth;
  }
  var startWeekDay = getDay(startOfMonth(date));
  var lastDayOfFirstWeek;
  if (startWeekDay >= weekStartsOn) {
    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
  } else {
    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  }
  var weekNumber = 1;
  if (currentDayOfMonth > lastDayOfFirstWeek) {
    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    weekNumber += Math.ceil(remainingDaysAfterFirstWeek / 7);
  }
  return weekNumber;
};
var getDayOfWeekStartingFromMonday = function getDayOfWeekStartingFromMonday(date) {
  return getDay(date) - 1 === -1 ? 6 : getDay(date) - 1;
};
var getDayAndWeekNumberFromDate = function getDayAndWeekNumberFromDate(_ref2) {
  var date = _ref2.date;
  var numbers = {
    dayNumber: 0,
    weekNumber: 0
  };
  numbers.dayNumber = getDayOfWeekStartingFromMonday(date);
  numbers.weekNumber = getWeekOfMonth(date, {
    weekStartsOn: 1
  }) - 1;
  return numbers;
};
var isToday = function isToday(date, userTimezone) {
  var dateTime = spacetime(date)["goto"](userTimezone);
  var startOfDay = spacetime.today().startOf('day');
  var endOfDay = spacetime.today().endOf('day');
  return (dateTime.isBefore(endOfDay) || dateTime.isEqual(endOfDay)) && (dateTime.isAfter(startOfDay) || dateTime.isEqual(startOfDay));
  /*const todayDate = spacetime(date).day();
  const todayWeek = spacetime(date).week();
  const todayDayInTimezone = spacetime.today(userTimezone).day();
  const todayWeekInTimezone = spacetime.today(userTimezone).week();
   return todayDate === todayDayInTimezone && todayWeekInTimezone === todayWeek;*/
};

var isTomorrow = function isTomorrow(date) {
  return isSameDay$1(date, addDays(new Date(), 1));
};
var isBeforeToday = function isBeforeToday(date, userTimezone) {
  return spacetime(date)["goto"](userTimezone).isBefore(spacetime.today().startOf('day'));
};
var isAfterToday = function isAfterToday(date, userTimezone) {
  return spacetime(date)["goto"](userTimezone).isAfter(spacetime.today().endOf('day'));
};
var isAfterTomorrow = function isAfterTomorrow(date) {
  return isAfter(date, addDays(startOfDay(new Date()), 1));
};
var isWeekend = function isWeekend(date) {
  return isWeekend$1(date);
};
var isSameDay = function isSameDay(date1, date2) {
  return isSameDay$1(date1, date2);
};
var intervalDaysOfMonth = function intervalDaysOfMonth(_ref3) {
  var date = _ref3.date;
  return eachDayOfInterval({
    start: startOfMonth(date),
    end: endOfMonth(date)
  });
};
var lastWeekOfPrevMonth = function lastWeekOfPrevMonth(_ref4) {
  var date = _ref4.date;
  var start = startOfWeek(startOfMonth(date), {
    weekStartsOn: 1
  });
  var end = subDays(startOfMonth(date), 1);
  return isBefore(end, start) ? [] : eachDayOfInterval({
    start: start,
    end: end
  });
};
var firstWeekOfNextMonth = function firstWeekOfNextMonth(_ref5) {
  var date = _ref5.date;
  var start = addDays(endOfMonth(date), 1);
  var end = endOfWeek(endOfMonth(date), {
    weekStartsOn: 1
  });
  return isAfter(start, end) ? [] : eachDayOfInterval({
    start: start,
    end: end
  });
};
var isAfterDate = function isAfterDate(dateToCompare, date) {
  return isAfter(dateToCompare, date);
};
var isSameDayDate = function isSameDayDate(dateLeft, dateRight) {
  return isSameDay(dateLeft, dateRight);
};
var addMonth = function addMonth(date) {
  var numberOfMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return addMonths(date, numberOfMonth);
};
var addMinutes = function addMinutes(date, minutes) {
  return addMinutes$1(date, minutes);
};
var subMinutes = function subMinutes(date, minutes) {
  return subMinutes$1(date, minutes);
};
var subMonth = function subMonth(date) {
  var numberOfMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return subMonths(date, numberOfMonth);
};
var formatDate = function formatDate(date, formatString) {
  if (!date) {
    throw new Error('date parameter is required');
  }
  return format(date, formatString);
};
var formatDistance = function formatDistance(date1, date2) {
  if (!date1 || !date2) {
    throw new Error('date parameter is required');
  }
  return formatDistance$1(date1, date2);
};
var formatDistanceToNow = function formatDistanceToNow(date) {
  if (!date) {
    throw new Error('date parameter is required');
  }
  return formatDistanceToNow$1(date);
};
var formatSecondToElapsedTime = function formatSecondToElapsedTime(seconds) {
  var helperDate = addSeconds(new Date(1970, 0, 1), seconds);
  return format(helperDate, 'HH:mm:ss');
};
var today = function today() {
  return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
};
var transformCalendarEventDate = function transformCalendarEventDate(dateTime) {
  var applyTZOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var day = dateTime.getDate();
  var hour = dateTime.getHours();
  var min = dateTime.getMinutes();
  var month = dateTime.getMonth() + 1;
  var year = dateTime.getFullYear();
  if (applyTZOffset) {
    hour += dateTime.getTimezoneOffset() / 60;
  }
  var monthStr = "0".concat(month).slice(-2);
  var hourStr = "0".concat(hour).slice(-2);
  var minStr = "0".concat(min).slice(-2);
  var dayStr = "0".concat(day).slice(-2);
  return {
    year: year,
    monthStr: monthStr,
    hourStr: hourStr,
    minStr: minStr,
    dayStr: dayStr
  };
};
var parseTimeToDatetime = function parseTimeToDatetime(timeToParse) {
  var unitTime = timeToParse.substr(-1);
  var time = Number.parseInt(timeToParse.substr(0, timeToParse.length - 1));
  var todayTime = new Date().getTime();
  var convert = 60 * 1000;
  if (unitTime === 'M') {
    return addMonths(new Date(), time);
  }
  if (unitTime === 'h') {
    convert = 60 * 60 * 1000;
  }
  if (unitTime === 'd') {
    convert = 24 * 60 * 60 * 1000;
  }
  return new Date(todayTime + convert * time);
};
var getDateFormatted = function getDateFormatted(date) {
  if ((date === null || date === void 0 ? void 0 : date.indexOf('T')) > 0) {
    return "".concat(date.split('T')[0].split('-').map(function (x) {
      if (x.length <= 1) {
        return x = "0".concat(x);
      }
      return x;
    }).join('-'), "T").concat(date.split('T')[1].split(':').map(function (x) {
      if (x.length <= 1) {
        return x = "0".concat(x);
      }
      return x;
    }).join(':'));
  }
  return date.split('-').map(function (x) {
    if (x.length <= 1) {
      return x = "0".concat(x);
    }
    return x;
  }).join('-');
};
var formatDateAsText = function formatDateAsText(text) {
  var patternFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{month} {date-ordinal}, {year}';
  var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getUserTimeZone();
  return text ? spacetime(text, 'UTC')["goto"](timeZone).format(patternFormat) : 'never';
};
var generateDatePrefix = function generateDatePrefix(date) {
  var diffDatePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isToday(date, getUserTimeZone())) {
    return 'Today ';
  }
  if (isYesterday(date)) {
    return 'Yesterday ';
  }
  if (isTomorrow(date)) {
    return 'Tomorrow ';
  }
  if (diffDatePrefix) {
    var diffDays = differenceInCalendarDays(date, new Date());
    return diffDays > 0 ? "In ".concat(diffDays, " days") : "".concat(-diffDays, " days ago");
  }
  return '';
};
var getDateTimestampString = function getDateTimestampString(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDay()).getTime().toString();
};
var getLocationFromCompleteTimeZone = function getLocationFromCompleteTimeZone(timezone) {
  var positionValue = getTimeZoneLocationPosition(timezone);
  return timezone.substring(positionValue + 1).replace(' ', '_');
};
var getUTCFromCompleteTimeZone = function getUTCFromCompleteTimeZone(timeZone) {
  var positionValue = getTimeZoneLocationPosition(timeZone);
  return timeZone.substring(0, positionValue);
};
var convertLocationToHourMinutes = function convertLocationToHourMinutes(timeZoneLocation) {
  var timeZoneFormatter = Intl.DateTimeFormat([], {
    timeZone: timeZoneLocation,
    hour: '2-digit',
    minute: '2-digit'
  });
  return timeZoneFormatter.format(new Date());
};

/**
 * @deprecated use parseTimeToDatetime instead
 */
var getUTCDate = function getUTCDate(date) {
  return new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000);
};
var getRoundedDateTime = function getRoundedDateTime(minutes) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var ms = 1000 * 60 * minutes; // convert minutes to ms
  var date = new Date(Math.round(d.getTime() / ms) * ms);
  return date.toISOString();
};
var getDifferenceInMinutes = function getDifferenceInMinutes(_ref6) {
  var _ref6$startDate = _ref6.startDate,
    startDate = _ref6$startDate === void 0 ? Date.now() : _ref6$startDate,
    endDate = _ref6.endDate;
  var diff = new Date(endDate).getTime() - new Date(startDate).getTime();
  return Math.ceil(diff / 60000);
};
var addHoursToStringDate = function addHoursToStringDate(date) {
  return date !== null && date !== void 0 && date.includes('T') ? date : "".concat(date, "T00:00:00.000");
};
var isDifferentYearThanCurrent = function isDifferentYearThanCurrent(date) {
  return new Date().getFullYear() !== new Date(date).getFullYear();
};
var getUserTimeZone = function getUserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * It returns the corrected day for a given UTC date. If the date is in full ISO format (e.g. 2020-01-01T00:00:00.000Z) it trims the time part.
 * Example: If a task is set for 2020-01-01T00:00:00.000Z, the returned date will be 2020-01-01T00:00:00.000Z on the local timezone of the user.
 * If a task is set for 2020-01-01 the returned date will be 2020-01-01T00:00:00.000Z on the local timezone of the user.
 *
 * @param {string} date
 * @param {string} timeZone if it's not declared not it would take the user computer timezone
 * @returns {Date} the corrected js date
 */
function parseUTCDateToLocal(date) {
  var _date;
  var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getUserTimeZone();
  var regexDateWithTime = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{3})?(z|Z)/g;
  if ((_date = date) !== null && _date !== void 0 && _date.match(regexDateWithTime)) {
    var utcDate = spacetime(date, 'UTC');
    date = utcDate.format('iso-short');
  }
  var s = spacetime(date, timeZone);
  return s.toNativeDate();
}
function parseUTCDateTimeToLocal(date) {
  var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getUserTimeZone();
  var s = spacetime(date, timeZone);
  return s.toNativeDate();
}

/**
 * It returns the string formatted day (YYYY-MM-DD) for a given UTC date. If the date is in full ISO format (e.g. 2020-01-01T00:00:00.000Z) it trims the time part.
 *
 * @param {string} date
 * @param {string} timeZone
 * @returns {String} the ISO short formatted date (YYYY-MM-DD)
 */
function getISOShortFormattedDate(date, timeZone) {
  var s = parseUTCDateToLocal(date, timeZone);
  return spacetime(s, timeZone).format('iso-short');
}

/**
 * It returns the string formatted day (YYYY-MM-DD)
 *
 * @param {Date} date
 */
function getISODate(date) {
  return "".concat(date.getFullYear(), "-").concat("0".concat(date.getMonth() + 1).slice(-2), "-").concat("0".concat(date.getDate()).slice(-2));
}
function add(date, unit, amount) {
  switch (unit) {
    case 'days':
      return addDays(date, amount);
    case 'hours':
      return addHours(date, amount);
    case 'minutes':
    default:
      return addMinutes(date, amount);
  }
}

var Afghanistan = [
	"asia/kabul"
];
var Albania = [
	"europe/tirane"
];
var Algeria = [
	"africa/algiers"
];
var Andorra = [
	"europe/andorra"
];
var Angola = [
	"africa/luanda"
];
var Antarctica = [
	"antarctica/casey",
	"antarctica/davis",
	"antarctica/vostok",
	"antarctica/mawson",
	"antarctica/syowa",
	"antarctica/troll",
	"antarctica/mcmurdo",
	"antarctica/south_pole",
	"antarctica/macquarie",
	"antarctica/dumontdurville",
	"antarctica/palmer",
	"antarctica/rothera"
];
var Argentina = [
	"america/argentina"
];
var Armenia = [
	"asia/yerevan"
];
var Australia = [
	"australia/adelaide",
	"australia/broken_hill",
	"australia/south",
	"australia/yancowinna",
	"australia/darwin",
	"australia/north",
	"australia/perth",
	"australia/west",
	"australia/eucla",
	"australia/currie",
	"australia/hobart",
	"australia/melbourne",
	"australia/sydney",
	"australia/act",
	"australia/canberra",
	"australia/nsw",
	"australia/tasmania",
	"australia/victoria",
	"australia/brisbane",
	"australia/lindeman",
	"australia/queensland",
	"australia/lord_howe",
	"australia/lhi"
];
var Austria = [
	"europe/vienna"
];
var Azerbaijan = [
	"asia/baku"
];
var Bahamas = [
	"america/nassau"
];
var Bahrain = [
	"asia/bahrain"
];
var Bangladesh = [
	"asia/dhaka"
];
var Barbados = [
	"america/barbados"
];
var Belarus = [
	"europe/minsk"
];
var Belgium = [
	"europe/brussels"
];
var Belize = [
	"america/belize"
];
var Benin = [
	"africa/porto-novo"
];
var Bhutan = [
	"asia/thimphu"
];
var Bolivia = [
	"america/la_paz"
];
var Botswana = [
	"africa/gaborone"
];
var Brazil = [
	"brazil/acre",
	"brazil/west",
	"brazil/east"
];
var Brunei = [
	"asia/brunei"
];
var Bulgaria = [
	"europe/sofia"
];
var Burundi = [
	"africa/bujumbura"
];
var Cambodia = [
	"asia/phnom_penh"
];
var Cameroon = [
	"africa/douala"
];
var Canada = [
	"canada/atlantic",
	"canada/central",
	"canada/east-saskatchewan",
	"canada/eastern",
	"canada/mountain",
	"canada/pacific",
	"canada/saskatchewan",
	"canada/yukon"
];
var Chad = [
	"africa/ndjamena"
];
var Chile = [
	"chile/continental"
];
var China = [
	"asia/shanghai"
];
var Colombia = [
	"america/bogota"
];
var Comoros = [
	"indian/comoro"
];
var Croatia = [
	"europe/zagreb"
];
var Cuba = [
	"america/havana"
];
var Cyprus = [
	"asia/nicosia"
];
var Denmark = [
	"europe/copenhagen",
	"atlantic/faroe"
];
var Djibouti = [
	"africa/djibouti"
];
var Dominica = [
	"america/dominica"
];
var Ecuador = [
	"america/guayaquil"
];
var Egypt = [
	"africa/cairo"
];
var Eritrea = [
	"africa/asmara",
	"africa/asmera"
];
var Estonia = [
	"europe/tallinn"
];
var Ethiopia = [
	"africa/addis_ababa"
];
var Fiji = [
	"pacific/fiji"
];
var Finland = [
	"europe/helsinki"
];
var France = [
	"europe/paris"
];
var Gabon = [
	"africa/libreville"
];
var Gambia = [
	"africa/banjul"
];
var Georgia = [
	"asia/tbilisi"
];
var Germany = [
	"europe/berlin"
];
var Ghana = [
	"africa/accra"
];
var Greece = [
	"europe/athens"
];
var Grenada = [
	"america/grenada"
];
var Guatemala = [
	"america/guatemala"
];
var Guinea = [
	"africa/conakry"
];
var Guyana = [
	"america/guyana"
];
var Haiti = [
	"america/port-au-prince"
];
var Honduras = [
	"america/tegucigalpa"
];
var Hungary = [
	"europe/budapest"
];
var Iceland = [
	"atlantic/reykjavik"
];
var India = [
	"asia/kolkata"
];
var Indonesia = [
	"asia/jakarta",
	"asia/makassar"
];
var Iran = [
	"asia/tehran"
];
var Iraq = [
	"asia/baghdad"
];
var Ireland = [
	"europe/dublin"
];
var Israel = [
	"asia/jerusalem"
];
var Italy = [
	"europe/rome"
];
var Jamaica = [
	"america/jamaica"
];
var Japan = [
	"asia/tokyo"
];
var Jordan = [
	"asia/amman"
];
var Kazakhstan = [
	"asia/almaty"
];
var Kenya = [
	"africa/nairobi"
];
var Kiribati = [
	"pacific/tarawa"
];
var Kuwait = [
	"asia/kuwait"
];
var Kyrgyzstan = [
	"asia/bishkek"
];
var Laos = [
	"asia/vientiane"
];
var Latvia = [
	"europe/riga"
];
var Lebanon = [
	"asia/beirut"
];
var Lesotho = [
	"africa/maseru"
];
var Liberia = [
	"africa/monrovia"
];
var Libya = [
	"africa/tripoli"
];
var Liechtenstein = [
	"europe/vaduz"
];
var Lithuania = [
	"europe/vilnius"
];
var Luxembourg = [
	"europe/luxembourg"
];
var Macau = [
	"asia/macau"
];
var Madagascar = [
	"indian/antananarivo"
];
var Malawi = [
	"africa/blantyre"
];
var Malaysia = [
	"asia/kuala_lumpur",
	"asia/kuching"
];
var Maldives = [
	"indian/maldives"
];
var Mali = [
	"africa/bamako"
];
var Malta = [
	"europe/malta"
];
var Mauritania = [
	"africa/nouakchott"
];
var Mauritius = [
	"indian/mauritius"
];
var Mexico = [
	"america/mexico_city",
	"mexico/bajanorte",
	"mexico/bajasur",
	"mexico/general"
];
var Moldova = [
	"europe/chisinau"
];
var Monaco = [
	"europe/monaco"
];
var Mongolia = [
	"asia/ulaanbaatar",
	"asia/hovd"
];
var Montenegro = [
	"europe/podgorica"
];
var Morocco = [
	"africa/casablanca"
];
var Mozambique = [
	"africa/maputo"
];
var Myanmar = [
	"asia/rangoon"
];
var Namibia = [
	"africa/windhoek"
];
var Nauru = [
	"pacific/nauru"
];
var Nepal = [
	"asia/kathmandu"
];
var Netherlands = [
	"europe/amsterdam"
];
var Nicaragua = [
	"america/managua"
];
var Niger = [
	"africa/niamey"
];
var Nigeria = [
	"africa/lagos"
];
var Norway = [
	"europe/oslo"
];
var Oman = [
	"asia/muscat"
];
var Pakistan = [
	"asia/karachi"
];
var Palau = [
	"pacific/palau"
];
var Palestine = [
	"asia/gaza",
	"asia/hebron"
];
var Panama = [
	"america/panama"
];
var Paraguay = [
	"america/asuncion"
];
var Peru = [
	"america/lima"
];
var Philippines = [
	"asia/manila"
];
var Poland = [
	"europe/warsaw"
];
var Portugal = [
	"europe/lisbon"
];
var Qatar = [
	"asia/qatar"
];
var Romania = [
	"europe/bucharest"
];
var Rwanda = [
	"africa/kigali"
];
var Samoa = [
	"pacific/samoa"
];
var Senegal = [
	"africa/dakar"
];
var Serbia = [
	"europe/belgrade"
];
var Seychelles = [
	"indian/mahe"
];
var Singapore = [
	"asia/singapore"
];
var Slovakia = [
	"europe/bratislava"
];
var Slovenia = [
	"europe/ljubljana"
];
var Somalia = [
	"africa/mogadishu"
];
var Spain = [
	"europe/madrid"
];
var Sudan = [
	"africa/khartoum"
];
var Suriname = [
	"america/paramaribo"
];
var Swaziland = [
	"africa/mbabane"
];
var Sweden = [
	"europe/stockholm"
];
var Switzerland = [
	"europe/zurich"
];
var Syria = [
	"asia/damascus"
];
var Taiwan = [
	"asia/taipei"
];
var Tajikistan = [
	"asia/dushanbe"
];
var Tanzania = [
	"africa/dar_es_salaam"
];
var Thailand = [
	"asia/bangkok"
];
var Togo = [
	"africa/lome"
];
var Tonga = [
	"pacific/tongatapu"
];
var Tunisia = [
	"africa/tunis"
];
var Turkey = [
	"europe/istanbul"
];
var Turkmenistan = [
	"asia/ashgabat"
];
var Tuvalu = [
	"pacific/funafuti"
];
var Uganda = [
	"africa/kampala"
];
var Ukraine = [
	"europe/kiev"
];
var Uruguay = [
	"america/montevideo"
];
var Uzbekistan = [
	"asia/samarkand"
];
var Vanuatu = [
	"pacific/efate"
];
var Venezuela = [
	"america/caracas"
];
var Vietnam = [
	"asia/ho_chi_minh"
];
var Yemen = [
	"asia/aden"
];
var Zambia = [
	"africa/lusaka"
];
var Zimbabwe = [
	"africa/harare"
];
var timezonesByCountry = {
	Afghanistan: Afghanistan,
	Albania: Albania,
	Algeria: Algeria,
	Andorra: Andorra,
	Angola: Angola,
	Antarctica: Antarctica,
	"Antigua and Barbuda": [
	"america/antigua"
],
	Argentina: Argentina,
	Armenia: Armenia,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": [
	"europe/sarajevo"
],
	Botswana: Botswana,
	Brazil: Brazil,
	Brunei: Brunei,
	Bulgaria: Bulgaria,
	"Burkina Faso": [
	"africa/ouagadougou"
],
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": [
	"atlantic/cape_verde"
],
	"Central African Republic": [
	"africa/bangui"
],
	Chad: Chad,
	Chile: Chile,
	China: China,
	Colombia: Colombia,
	Comoros: Comoros,
	"Costa Rica": [
	"america/costa_rica"
],
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": [
	"europe/prague"
],
	"Democratic Republic of the Congo": [
	"africa/kinshasa",
	"africa/lubumbashi"
],
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": [
	"america/santo_domingo"
],
	"East Timor": [
	"asia/dili"
],
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": [
	"america/el_salvador"
],
	"Equatorial Guinea": [
	"africa/malabo"
],
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Federated States of Micronesia": [
	"pacific/pohnpei",
	"pacific/chuuk"
],
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Greece: Greece,
	Grenada: Grenada,
	Guatemala: Guatemala,
	Guinea: Guinea,
	"Guinea-Bissau": [
	"africa/bissau"
],
	Guyana: Guyana,
	Haiti: Haiti,
	Honduras: Honduras,
	"Hong Kong": [
	"asia/hong_kong"
],
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	Iran: Iran,
	Iraq: Iraq,
	Ireland: Ireland,
	Israel: Israel,
	Italy: Italy,
	"Ivory Coast": [
	"africa/abidjan"
],
	Jamaica: Jamaica,
	Japan: Japan,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, North": [
	"asia/pyongyang"
],
	"Korea, South": [
	"asia/seoul"
],
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	Laos: Laos,
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macau: Macau,
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": [
	"pacific/kwajalein",
	"pacific/majuro"
],
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mexico: Mexico,
	Moldova: Moldova,
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"New Zealand": [
	"pacific/auckland"
],
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	"North Macedonia": [
	"europe/skopje"
],
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	Palestine: Palestine,
	Panama: Panama,
	"Papua New Guinea": [
	"pacific/port_moresby"
],
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": [
	"america/puerto_rico"
],
	Qatar: Qatar,
	"Republic of the Congo": [
	"africa/brazzaville"
],
	Romania: Romania,
	"Russian Federation": [
	"europe/moscow"
],
	Rwanda: Rwanda,
	"Saint Kitts and Nevis": [
	"america/st_kitts"
],
	"Saint Lucia": [
	"america/st_lucia"
],
	"Saint Vincent and the Grenadines": [
	"america/st_vincent"
],
	Samoa: Samoa,
	"San Marino": [
	"europe/san_marino"
],
	"Saudi Arabia": [
	"asia/riyadh"
],
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": [
	"africa/freetown"
],
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": [
	"pacific/guadalcanal"
],
	Somalia: Somalia,
	"South Africa": [
	"africa/johannesburg"
],
	"South Sudan": [
	"africa/juba"
],
	Spain: Spain,
	"Sri Lanka": [
	"asia/colombo"
],
	Sudan: Sudan,
	Suriname: Suriname,
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	Syria: Syria,
	"São Tomé and Príncipe": [
	"africa/sao_tome"
],
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	Tanzania: Tanzania,
	Thailand: Thailand,
	Togo: Togo,
	Tonga: Tonga,
	"Trinidad and Tobago": [
	"america/port_of_spain"
],
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": [
	"asia/dubai"
],
	"United Kingdom": [
	"europe/london"
],
	"United States": [
	"us/eastern",
	"us/central",
	"us/mountain",
	"us/pacific"
],
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	"Vatican City": [
	"europe/vatican"
],
	Venezuela: Venezuela,
	Vietnam: Vietnam,
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

var rawJson = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Afghanistan: Afghanistan,
  Albania: Albania,
  Algeria: Algeria,
  Andorra: Andorra,
  Angola: Angola,
  Antarctica: Antarctica,
  Argentina: Argentina,
  Armenia: Armenia,
  Australia: Australia,
  Austria: Austria,
  Azerbaijan: Azerbaijan,
  Bahamas: Bahamas,
  Bahrain: Bahrain,
  Bangladesh: Bangladesh,
  Barbados: Barbados,
  Belarus: Belarus,
  Belgium: Belgium,
  Belize: Belize,
  Benin: Benin,
  Bhutan: Bhutan,
  Bolivia: Bolivia,
  Botswana: Botswana,
  Brazil: Brazil,
  Brunei: Brunei,
  Bulgaria: Bulgaria,
  Burundi: Burundi,
  Cambodia: Cambodia,
  Cameroon: Cameroon,
  Canada: Canada,
  Chad: Chad,
  Chile: Chile,
  China: China,
  Colombia: Colombia,
  Comoros: Comoros,
  Croatia: Croatia,
  Cuba: Cuba,
  Cyprus: Cyprus,
  Denmark: Denmark,
  Djibouti: Djibouti,
  Dominica: Dominica,
  Ecuador: Ecuador,
  Egypt: Egypt,
  Eritrea: Eritrea,
  Estonia: Estonia,
  Ethiopia: Ethiopia,
  Fiji: Fiji,
  Finland: Finland,
  France: France,
  Gabon: Gabon,
  Gambia: Gambia,
  Georgia: Georgia,
  Germany: Germany,
  Ghana: Ghana,
  Greece: Greece,
  Grenada: Grenada,
  Guatemala: Guatemala,
  Guinea: Guinea,
  Guyana: Guyana,
  Haiti: Haiti,
  Honduras: Honduras,
  Hungary: Hungary,
  Iceland: Iceland,
  India: India,
  Indonesia: Indonesia,
  Iran: Iran,
  Iraq: Iraq,
  Ireland: Ireland,
  Israel: Israel,
  Italy: Italy,
  Jamaica: Jamaica,
  Japan: Japan,
  Jordan: Jordan,
  Kazakhstan: Kazakhstan,
  Kenya: Kenya,
  Kiribati: Kiribati,
  Kuwait: Kuwait,
  Kyrgyzstan: Kyrgyzstan,
  Laos: Laos,
  Latvia: Latvia,
  Lebanon: Lebanon,
  Lesotho: Lesotho,
  Liberia: Liberia,
  Libya: Libya,
  Liechtenstein: Liechtenstein,
  Lithuania: Lithuania,
  Luxembourg: Luxembourg,
  Macau: Macau,
  Madagascar: Madagascar,
  Malawi: Malawi,
  Malaysia: Malaysia,
  Maldives: Maldives,
  Mali: Mali,
  Malta: Malta,
  Mauritania: Mauritania,
  Mauritius: Mauritius,
  Mexico: Mexico,
  Moldova: Moldova,
  Monaco: Monaco,
  Mongolia: Mongolia,
  Montenegro: Montenegro,
  Morocco: Morocco,
  Mozambique: Mozambique,
  Myanmar: Myanmar,
  Namibia: Namibia,
  Nauru: Nauru,
  Nepal: Nepal,
  Netherlands: Netherlands,
  Nicaragua: Nicaragua,
  Niger: Niger,
  Nigeria: Nigeria,
  Norway: Norway,
  Oman: Oman,
  Pakistan: Pakistan,
  Palau: Palau,
  Palestine: Palestine,
  Panama: Panama,
  Paraguay: Paraguay,
  Peru: Peru,
  Philippines: Philippines,
  Poland: Poland,
  Portugal: Portugal,
  Qatar: Qatar,
  Romania: Romania,
  Rwanda: Rwanda,
  Samoa: Samoa,
  Senegal: Senegal,
  Serbia: Serbia,
  Seychelles: Seychelles,
  Singapore: Singapore,
  Slovakia: Slovakia,
  Slovenia: Slovenia,
  Somalia: Somalia,
  Spain: Spain,
  Sudan: Sudan,
  Suriname: Suriname,
  Swaziland: Swaziland,
  Sweden: Sweden,
  Switzerland: Switzerland,
  Syria: Syria,
  Taiwan: Taiwan,
  Tajikistan: Tajikistan,
  Tanzania: Tanzania,
  Thailand: Thailand,
  Togo: Togo,
  Tonga: Tonga,
  Tunisia: Tunisia,
  Turkey: Turkey,
  Turkmenistan: Turkmenistan,
  Tuvalu: Tuvalu,
  Uganda: Uganda,
  Ukraine: Ukraine,
  Uruguay: Uruguay,
  Uzbekistan: Uzbekistan,
  Vanuatu: Vanuatu,
  Venezuela: Venezuela,
  Vietnam: Vietnam,
  Yemen: Yemen,
  Zambia: Zambia,
  Zimbabwe: Zimbabwe,
  'default': timezonesByCountry
});

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var ellipsis = function ellipsis(str, maxLength) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'end' : _ref$side,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '...' : _ref$prefix;
  if (str && str.length > maxLength) {
    var length = maxLength - prefix.length;
    switch (side) {
      case 'start':
        return prefix + str.slice(-length);
      case 'end':
      default:
        return str.slice(0, length) + prefix;
    }
  }
  return str;
};
var commaAndFormatArray = function commaAndFormatArray(array) {
  var last = array.pop();
  return array.join(', ') + ' and ' + last;
};
var indefiniteArticle = function indefiniteArticle(word) {
  var pattern = /^([aeiou])/i;
  var startsWithVowel = pattern.test(word);
  return startsWithVowel ? 'an' : 'a';
};
var toCamelCase = camelCase;
var toCamelCaseUpperFirst = function toCamelCaseUpperFirst(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return toCamelCase(str).replace(/^[a-z]/g, function (s) {
    return s.toUpperCase();
  });
};
var toSentenceCase = function toSentenceCase(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
var toTitleCase = function toTitleCase(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return startCase(lowerCase(str));
};
var isHtml = function isHtml(str) {
  var regex = RegExp(/(<([^>]+)>)/gi);
  return regex.test(str);
};
var stringToHTML = function stringToHTML(str) {
  var dom = document.createElement('div');
  dom.innerHTML = str;
  return dom;
};
var HTMLToString = function HTMLToString(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};
var numberWithDots = function numberWithDots(number) {
  return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.');
};
var replaceVariables = function replaceVariables(text, values) {
  var regex = new RegExp(/##(.*?)##/);
  if (!text) {
    return null;
  }
  if (!values) {
    return text;
  }
  return text.split(regex).reduce(function (prev, current, i) {
    if (!i) {
      return [current];
    }
    return prev.concat(values[current] || current);
  }, []);
};
var numberToOrdinalString = function numberToOrdinalString(number) {
  var suffixes = ['th', 'st', 'nd', 'rd'];
  var v = number % 100;
  return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};
var generateShortName = function generateShortName(text) {
  var _initials$shift, _initials$pop, _initials;
  var rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
  var initials = _toConsumableArray(text.matchAll(rgx)) || [];
  initials = ((((_initials$shift = initials.shift()) === null || _initials$shift === void 0 ? void 0 : _initials$shift[1]) || '') + (((_initials$pop = initials.pop()) === null || _initials$pop === void 0 ? void 0 : _initials$pop[1]) || '')).toUpperCase();
  return String((_initials = initials) === null || _initials === void 0 ? void 0 : _initials.slice(0, 2));
};
var emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var specialChar = ['ñ', 'ü'];
var isEmail = function isEmail(email) {
  return email !== undefined && email !== null && email !== '' && emailRe.test(String(email).toLowerCase()) && !specialChar.some(function (_char) {
    return email.toLowerCase().includes(_char);
  });
};

// https://mathiasbynens.be/demo/url-regex
// https://gist.github.com/dperini/729294
var reWeburl = new RegExp('^' +
// protocol identifier (optional)
// short syntax // still required
'(?:(?:(?:https?|ftp):)?\\/\\/)?' +
// user:pass BasicAuth (optional)
'(?:\\S+(?::\\S*)?@)?' + '(?:' +
// IP address exclusion
// private & local networks
'(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
// IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broadcast addresses
// (first & last IP address of each class)
'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' +
// host & domain names, may end with dot
// can be replaced by a shortest alternative
// (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
'(?:' + '(?:' + "[a-z0-9\\u00a1-\\uffff]" + "[a-z0-9\\u00a1-\\uffff_-]{0,62}" + ')?' + "[a-z0-9\\u00a1-\\uffff]\\." + ')+' +
// TLD identifier name, may end with dot
"(?:[a-z\\u00a1-\\uffff]{2,}\\.?)" + ')' +
// port number (optional)
'(?::\\d{2,5})?' +
// resource path (optional)
'(?:[/?#]\\S*)?' + '$', 'i');
var isUrl = function isUrl(string) {
  return string !== undefined && string !== null && typeof string === 'string' && !!string.match(reWeburl);
};
function linkify(text) {
  //Check that text is a string and has length
  if (!text || typeof text !== 'string' || text.length === 0) {
    return text;
  }
  var replacePattern1, replacePattern2, replacedText;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
  replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
  return replacedText;
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var data = rawJson;
var map = Object.keys(data).map(function (x) {
  return _defineProperty$4({}, x.toUpperCase(), data[x]);
}).reduce(function (a, b) {
  return _objectSpread$3(_objectSpread$3({}, a), b);
}, {});

/**
 * Private functions. Meant only for testing
 */
var privateTimeZoneFunctions = function privateTimeZoneFunctions() {
  var formatCountryToName = function formatCountryToName(country) {
    if (lookup.byCountry(toTitleCase(country))) {
      return country.toUpperCase();
    } else {
      var c = lookup.byIso(country);
      if (c != undefined) return c.country.toUpperCase();else throw new Error('invalid country');
    }
  };

  /**
   * Returns a list containing the corresponding timezones for the input
   * @param country string can be a timezone (sth/sth) or a country name
   */
  var getCountryTimezones = function getCountryTimezones(country) {
    if (!country) return undefined;else if (country.includes('/')) {
      var split = country.split(' ');
      return [split[split.length - 1].toLowerCase()];
    } else {
      try {
        return map[formatCountryToName(country)];
      } catch (e) {
        return undefined;
      }
    }
  };
  var getNow = function getNow(timezone) {
    try {
      return spacetime.now(timezone);
    } catch (e) {
      return undefined;
    }
  };
  var parseTimezoneToNowList = function parseTimezoneToNowList(timezones) {
    return timezones.map(function (x) {
      return getNow(x);
    }).filter(function (x) {
      return x != undefined;
    });
  };
  var getFirstAndLastTimezone = function getFirstAndLastTimezone(spaceTimes) {
    if (!spaceTimes || spaceTimes.length === 0) {
      return undefined;
    }
    if (spaceTimes.length === 1) {
      return ["".concat(spaceTimes[0].time())];
    }
    spaceTimes.sort(function (a, b) {
      return a.timezone().current.offset - b.timezone().current.offset;
    });
    var sameFirstAndLast = spaceTimes[0].time() === spaceTimes[spaceTimes.length - 1].time();
    return sameFirstAndLast ? ["".concat(spaceTimes[0].time())] : ["".concat(spaceTimes[0].time()), "".concat(spaceTimes[spaceTimes.length - 1].time())];
  };
  var getFirstAndLastSpaceTime = function getFirstAndLastSpaceTime(timezones) {
    var nows = parseTimezoneToNowList(timezones);
    return getFirstAndLastTimezone(nows);
  };
  return {
    getCountryTimezones: getCountryTimezones,
    parseTimezoneToNowList: parseTimezoneToNowList,
    getFirstAndLastTimezone: getFirstAndLastTimezone,
    getFirstAndLastSpaceTime: getFirstAndLastSpaceTime
  };
};
var _privateTimeZoneFunct = privateTimeZoneFunctions(),
  getCountryTimezones = _privateTimeZoneFunct.getCountryTimezones,
  getFirstAndLastSpaceTime = _privateTimeZoneFunct.getFirstAndLastSpaceTime;

/**
 * Get current time on the specified territory
 * @param countryOrTimeZone timezone (spacetime library (iana code)) or country (name, ISO2, ISO3, ISOno)
 * @returns list of length 1 for timezone and list of 2 now times for the country (earliest & latest) , in format hh:mm{am,pm} (ex: [11:09am, 01:09pm])
 */
var getCurrentTime = function getCurrentTime(countryOrTimeZone) {
  var timezones = getCountryTimezones(countryOrTimeZone);
  if (timezones === undefined) return undefined;
  return getFirstAndLastSpaceTime(timezones);
};
var getCurrentTimeBeautiful = function getCurrentTimeBeautiful(countryOrTimeZone) {
  var nows = getCurrentTime(countryOrTimeZone);
  if (nows == undefined) return undefined;
  if (nows.length === 1) {
    return "It's ".concat(nows[0], " for");
  } else if (nows.length === 2) {
    return "It's between ".concat(nows[0], " and ").concat(nows[1], " for");
  }
};
var getCurrentTimeSimple = function getCurrentTimeSimple(countryOrTimeZone) {
  var nows = getCurrentTime(countryOrTimeZone);
  if (nows == undefined) return undefined;
  if (nows.length === 1) {
    return " ".concat(nows[0], " for");
  } else if (nows.length === 2) {
    return " ".concat(nows[0], " to ").concat(nows[1], " for");
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var addTaskDateGrouping = function addTaskDateGrouping(items, dateLogicRole, isOverdue) {
  return items.map(function (item, index) {
    var isItemOverdue = isOverdue(item);
    var date = new Date(addHoursToStringDate(getValueFromLogicRole(item, dateLogicRole)));
    var previous = items[index - 1];
    var next = items[index + 1];
    var previousItemDate = previous && new Date(addHoursToStringDate(getValueFromLogicRole(previous, dateLogicRole)));
    var nextItemDate = next && new Date(addHoursToStringDate(getValueFromLogicRole(next, dateLogicRole)));
    var formattedDay = isValid(date) ? format(date, 'MMMM do, yyyy') : '';
    var dateDay = isValid(date) ? parse(formattedDay, 'MMMM do, yyyy', new Date()) : '';
    var hashDate = getDateTimestampString(date);
    return _objectSpread$2(_objectSpread$2({}, item), {}, {
      taskDate: {
        isFirstOfDay: !previousItemDate || !isSameDay$1(date, previousItemDate) && !isItemOverdue,
        isLastOfDay: !nextItemDate || !isSameDay$1(date, nextItemDate) && !isItemOverdue || isItemOverdue && !isOverdue(next),
        day: dateDay,
        formattedDate: !isItemOverdue && formattedDay,
        prefix: !isItemOverdue ? generateDatePrefix(date, true) : 'Overdue',
        hashDate: hashDate
      }
    });
  });
};
function canBeMarkedAsDone(task) {
  //Check if task.date is an ISO date with time
  var useDateTime = task.date && task.date.length > 10;
  if (task.skippable) {
    return {
      disabled: false,
      reason: task.status === TASK_STATUS_VALUE_LOGIC_ROLE.OVERDUE ? 'When you complete this task it will be marked as Completed Overdue' : 'Mark as done'
    };
  }
  if (task.type === TASK_TYPE.NEXT_STEP || task.type === TASK_TYPE.MEETING) {
    return {
      disabled: false,
      reason: 'Mark as done'
    };
  }
  var beforeToday = isBeforeToday(task.date, getUserTimeZone());
  var spaceTimeDate = spacetime(task.date);
  var spaceTimeToday = spacetime.today();
  var spaceTimeDateisBeforeToday = spaceTimeDate.isBefore(spaceTimeToday);
  if (task.type === TASK_TYPE.PROSPECT_CADENCE && task.status === TASK_STATUS_VALUE_LOGIC_ROLE.TODO) {
    // Future
    var isFutureWithTime = useDateTime && isAfterToday(task.date, getUserTimeZone());
    if (useDateTime ? isFutureWithTime : spaceTimeDate.isAfter(spaceTimeToday)) {
      return {
        disabled: true,
        reason: 'This is a task for the future. You cannot mark it as done.'
      };
    }

    // Past
    var isPastWithTime = useDateTime && beforeToday;
    if (useDateTime ? isPastWithTime : spaceTimeDateisBeforeToday) {
      return {
        disabled: false,
        reason: 'Mark as done'
      };
    }

    // Today
    var isTodayWithTime = useDateTime && isToday(task.date, getUserTimeZone());
    if (useDateTime ? isTodayWithTime : spaceTimeDate.isEqual(spaceTimeToday)) {
      var disabled = !task.lastAttemptDate || task.lastAttemptDate && (useDateTime ? isBeforeToday(task.lastAttemptDate, getUserTimeZone()) : spacetime(task.lastAttemptDate).isBefore(spaceTimeToday));
      return {
        disabled: disabled,
        reason: disabled ? 'Make at least one attempt to mark as done' : 'Mark as done'
      };
    }
  }
  if (task.type === TASK_TYPE.PROSPECT_CADENCE && task.status === TASK_STATUS_VALUE_LOGIC_ROLE.OVERDUE && (useDateTime ? beforeToday : spaceTimeDateisBeforeToday)) {
    var _disabled = !task.lastAttemptDate || spacetime(task.lastAttemptDate).isBefore(spaceTimeDate);
    return {
      disabled: _disabled,
      reason: _disabled ? 'Make at least one attempt to mark as done' : 'When you complete this task it will be marked as Completed Overdue'
    };
  }
  // We should never get here, but just in case
  return {
    disabled: false,
    reason: 'Mark as done'
  };
}
var getButtonMarkAsDone = function getButtonMarkAsDone(_ref) {
  var bobjectLastAttemptDate = _ref.bobjectLastAttemptDate,
    taskStatus = _ref.taskStatus,
    taskType = _ref.taskType,
    taskIsAutomated = _ref.taskIsAutomated,
    taskDateField = _ref.taskDateField;
  var _canBeMarkedAsDone = canBeMarkedAsDone({
      skippable: taskIsAutomated !== TASK_AUTOMATED_VALUE.AUTOMATED_YES,
      status: taskStatus,
      type: taskType,
      date: taskDateField,
      lastAttemptDate: bobjectLastAttemptDate
    }),
    disabled = _canBeMarkedAsDone.disabled,
    reason = _canBeMarkedAsDone.reason;
  return {
    disabled: disabled,
    tooltip: reason
  };
};
var getTaskReferenceBobject = function getTaskReferenceBobject(bobject) {
  var _getFieldByLogicRole, _getFieldByLogicRole2, _getFieldByLogicRole3;
  if (!bobject) {
    throw new Error('bobject parameter is required');
  }
  var company = (_getFieldByLogicRole = getFieldByLogicRole(bobject, TASK_FIELDS_LOGIC_ROLE.COMPANY)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.referencedBobject;
  var lead = (_getFieldByLogicRole2 = getFieldByLogicRole(bobject, TASK_FIELDS_LOGIC_ROLE.LEAD)) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.referencedBobject;
  var opportunity = (_getFieldByLogicRole3 = getFieldByLogicRole(bobject, TASK_FIELDS_LOGIC_ROLE.OPPORTUNITY)) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.referencedBobject;
  if (opportunity) {
    return opportunity;
  } else if (lead) {
    return lead;
  } else if (company) {
    return company;
  }
};
var getTaskLocalTime = function getTaskLocalTime(task) {
  var _getFieldByLogicRole4, _getFieldByLogicRole5;
  var small = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!task) {
    throw new Error('task parameter is required');
  }
  var company = (_getFieldByLogicRole4 = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.COMPANY)) === null || _getFieldByLogicRole4 === void 0 ? void 0 : _getFieldByLogicRole4.referencedBobject;
  var lead = (_getFieldByLogicRole5 = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.LEAD)) === null || _getFieldByLogicRole5 === void 0 ? void 0 : _getFieldByLogicRole5.referencedBobject;
  /*const opportunity = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.OPPORTUNITY)
    ?.referencedBobject;
     // TODO - How to get the lead without going through the url
    if (opportunity && !lead) {
    const contactBobjects = useContactBobjects();
    const leadId = getFieldByLogicRole(opportunity, OPPORTUNITY_FIELDS_LOGIC_ROLE.PRIMARY_CONTACT)
      ?.value;
    const filteredLeads = contactBobjects?.leads?.filter(lead => leadId === lead?.id?.value);
    if (filteredLeads?.length > 0) lead = filteredLeads[0];
  } */
  if (lead) {
    var leadTimeZone = getTextFromLogicRole(lead, LEAD_FIELDS_LOGIC_ROLE.TIME_ZONE);
    var leadNowTime = leadTimeZone && getCurrentTimeBeautiful(leadTimeZone);
    if (leadNowTime) return leadNowTime;
  }
  var companyCountry = getTextFromLogicRole(company, COMPANY_FIELDS_LOGIC_ROLE.COUNTRY);
  var companyTimeZone = getTextFromLogicRole(company, COMPANY_FIELDS_LOGIC_ROLE.TIME_ZONE);
  return small ? getCurrentTimeSimple(companyTimeZone !== null && companyTimeZone !== void 0 ? companyTimeZone : companyCountry) : getCurrentTimeBeautiful(companyTimeZone !== null && companyTimeZone !== void 0 ? companyTimeZone : companyCountry);
};
var isScheduledTask = function isScheduledTask(task) {
  var _getFieldByLogicRole6;
  return ((_getFieldByLogicRole6 = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.TASK_TYPE)) === null || _getFieldByLogicRole6 === void 0 ? void 0 : _getFieldByLogicRole6.valueLogicRole) === TASK_TYPE.NEXT_STEP;
};
var isCadenceTask = function isCadenceTask(task) {
  var _getFieldByLogicRole7;
  return ((_getFieldByLogicRole7 = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.TASK_TYPE)) === null || _getFieldByLogicRole7 === void 0 ? void 0 : _getFieldByLogicRole7.valueLogicRole) === TASK_TYPE.PROSPECT_CADENCE;
};
var isCallTask = function isCallTask(task) {
  var _getFieldByLogicRole8;
  return ((_getFieldByLogicRole8 = getFieldByLogicRole(task, TASK_ACTION.CALL)) === null || _getFieldByLogicRole8 === void 0 ? void 0 : _getFieldByLogicRole8.valueLogicRole) === TASK_ACTION_VALUE.CALL_YES;
};
var isEmailTask = function isEmailTask(task) {
  var _getFieldByLogicRole9;
  return ((_getFieldByLogicRole9 = getFieldByLogicRole(task, TASK_ACTION.EMAIL)) === null || _getFieldByLogicRole9 === void 0 ? void 0 : _getFieldByLogicRole9.valueLogicRole) === TASK_ACTION_VALUE.EMAIL_YES;
};
var isAutomatedEmailTask = function isAutomatedEmailTask(task) {
  var _getFieldByLogicRole10;
  return ((_getFieldByLogicRole10 = getFieldByLogicRole(task, TASK_ACTION.AUTOMATED_EMAIL)) === null || _getFieldByLogicRole10 === void 0 ? void 0 : _getFieldByLogicRole10.valueLogicRole) === TASK_ACTION_VALUE.AUTOMATED_EMAIL_YES;
};
var isLinkedinMessageTask = function isLinkedinMessageTask(task) {
  var _getFieldByLogicRole11;
  return ((_getFieldByLogicRole11 = getFieldByLogicRole(task, TASK_ACTION.LINKEDIN_MESSAGE)) === null || _getFieldByLogicRole11 === void 0 ? void 0 : _getFieldByLogicRole11.valueLogicRole) === TASK_ACTION_VALUE.LINKEDIN_MESSAGE_YES;
};
var isMeetingTypeTask = function isMeetingTypeTask(task) {
  var _getFieldByLogicRole12;
  var taskType = (_getFieldByLogicRole12 = getFieldByLogicRole(task, TASK_FIELDS_LOGIC_ROLE.TASK_TYPE)) === null || _getFieldByLogicRole12 === void 0 ? void 0 : _getFieldByLogicRole12.valueLogicRole;
  return taskType === TASK_TYPE.MEETING || taskType === (TASK_TYPE === null || TASK_TYPE === void 0 ? void 0 : TASK_TYPE.CONTACT_BEFORE_MEETING);
};
function getTaskType(task) {
  var taskTypes = [];
  if (isScheduledTask(task)) taskTypes.push(TASK_TYPE.NEXT_STEP);
  if (isCallTask(task)) taskTypes.push(TASK_ACTION.CALL);
  if (isEmailTask(task)) taskTypes.push(TASK_ACTION.EMAIL);
  if (isAutomatedEmailTask(task)) taskTypes.push(TASK_ACTION.AUTOMATED_EMAIL);
  if (isLinkedinMessageTask(task)) taskTypes.push(TASK_ACTION.LINKEDIN_MESSAGE);
  if (isMeetingTypeTask(task)) taskTypes.push(TASK_TYPE.MEETING);
  return taskTypes;
}

var _cardElementsDictiona;
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var cardElementsDictionary = (_cardElementsDictiona = {}, _defineProperty$2(_cardElementsDictiona, BOBJECT_TYPES.COMPANY, {
  fields: [COMPANY_FIELDS_LOGIC_ROLE.NAME, COMPANY_FIELDS_LOGIC_ROLE.NUMBER_OF_LEADS, COMPANY_FIELDS_LOGIC_ROLE.TARGET_MARKET, COMPANY_FIELDS_LOGIC_ROLE.SOURCE, COMPANY_FIELDS_LOGIC_ROLE.ASSIGNED_TO]
}), _defineProperty$2(_cardElementsDictiona, BOBJECT_TYPES.LEAD, {
  fields: [LEAD_FIELDS_LOGIC_ROLE.FULL_NAME, LEAD_FIELDS_LOGIC_ROLE.ICP, LEAD_FIELDS_LOGIC_ROLE.COMPANY, LEAD_FIELDS_LOGIC_ROLE.SOURCE, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO]
}), _defineProperty$2(_cardElementsDictiona, BOBJECT_TYPES.OPPORTUNITY, {
  fields: [OPPORTUNITY_FIELDS_LOGIC_ROLE.AMOUNT, OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME, OPPORTUNITY_FIELDS_LOGIC_ROLE.COMPANY, OPPORTUNITY_FIELDS_LOGIC_ROLE.ASSIGNED_TO]
}), _defineProperty$2(_cardElementsDictiona, BOBJECT_TYPES.TASK, {
  fields: [TASK_FIELDS_LOGIC_ROLE.SCHEDULED_DATETIME, TASK_FIELDS_LOGIC_ROLE.TITLE, ACTIVITY_FIELDS_LOGIC_ROLE.TIME, 'CUSTOM_TASK_TIMEZONE', TASK_FIELDS_LOGIC_ROLE.OPPORTUNITY, TASK_FIELDS_LOGIC_ROLE.LEAD, TASK_FIELDS_LOGIC_ROLE.COMPANY, LEAD_FIELDS_LOGIC_ROLE.LINKEDIN_URL, LEAD_FIELDS_LOGIC_ROLE.SOURCE, LEAD_FIELDS_LOGIC_ROLE.NURTURING_REASONS, COMPANY_FIELDS_LOGIC_ROLE.SOURCE, COMPANY_FIELDS_LOGIC_ROLE.NURTURING_REASONS, COMPANY_FIELDS_LOGIC_ROLE.COUNTRY, TASK_FIELDS_LOGIC_ROLE.ASSIGNED_TO]
}), _cardElementsDictiona);
var MULTI_INFO_BASED_FIELDS = [COMPANY_FIELDS_LOGIC_ROLE.NAME, LEAD_FIELDS_LOGIC_ROLE.FULL_NAME, OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME, TASK_FIELDS_LOGIC_ROLE.TITLE, COMPANY_FIELDS_LOGIC_ROLE.ASSIGNED_TO, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO, OPPORTUNITY_FIELDS_LOGIC_ROLE.ASSIGNED_TO, TASK_FIELDS_LOGIC_ROLE.ASSIGNED_TO];
var REFERENCE_FIELDS = [LEAD_FIELDS_LOGIC_ROLE.COMPANY, OPPORTUNITY_FIELDS_LOGIC_ROLE.COMPANY, TASK_FIELDS_LOGIC_ROLE.OPPORTUNITY, TASK_FIELDS_LOGIC_ROLE.COMPANY, TASK_FIELDS_LOGIC_ROLE.LEAD];
var BASE_REFERENCE_FIELDS = [COMPANY_FIELDS_LOGIC_ROLE.SOURCE, LEAD_FIELDS_LOGIC_ROLE.SOURCE];
var generateBobjectBasedData = function generateBobjectBasedData(bobject, fieldArray) {
  var _bobject$id, _bobject$id2;
  var mainBobjectType = bobject === null || bobject === void 0 ? void 0 : (_bobject$id = bobject.id) === null || _bobject$id === void 0 ? void 0 : _bobject$id.typeName;
  var _ref = cardElementsDictionary[mainBobjectType] || {},
    fields = _ref.fields;
  var referencedBobjectId = bobject === null || bobject === void 0 ? void 0 : (_bobject$id2 = bobject.id) === null || _bobject$id2 === void 0 ? void 0 : _bobject$id2.objectId;
  var translatedFields = [{
    logicRole: '',
    value: ''
  }];
  var fieldsToParse = fieldArray || fields;
  fieldsToParse === null || fieldsToParse === void 0 ? void 0 : fieldsToParse.forEach(function (logicRole) {
    var referencedBobjectType = getBobjectFromLogicRole(logicRole);
    var value;
    if (MULTI_INFO_BASED_FIELDS.includes(logicRole)) {
      value = getFieldByLogicRole(bobject, logicRole);
    } else if (REFERENCE_FIELDS.includes(logicRole) || referencedBobjectType && mainBobjectType !== referencedBobjectType) {
      var _getFieldByLogicRole;
      value = (_getFieldByLogicRole = getFieldByLogicRole(bobject, logicRole)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.referencedBobject;
      if (referencedBobjectType && mainBobjectType !== referencedBobjectType) {
        var _getFieldByLogicRole2;
        var referencedBobject = getTaskReferenceBobject(bobject);
        if (!BASE_REFERENCE_FIELDS.includes(logicRole)) referencedBobject = (_getFieldByLogicRole2 = getFieldByLogicRole(bobject, TASK_FIELDS_LOGIC_ROLE[referencedBobjectType.toUpperCase()])) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.referencedBobject;
        value = getTextFromLogicRole(referencedBobject, logicRole);
      } else if (!(logicRole !== null && logicRole !== void 0 && logicRole.includes(referencedBobjectType.toUpperCase()))) {
        var _getFieldByLogicRole3;
        var _mainBobjectType = getBobjectFromLogicRole(logicRole);
        var mainBobject = (_getFieldByLogicRole3 = getFieldByLogicRole(bobject, FIELDS_LOGIC_ROLE[referencedBobjectType][_mainBobjectType.toUpperCase()])) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.referencedBobject;
        translatedFields.push({
          logicRole: logicRole,
          value: getTextFromLogicRole(mainBobject, logicRole)
        });
      }
    } else {
      value = getTextFromLogicRole(bobject, logicRole);
    }
    translatedFields.push({
      logicRole: logicRole,
      value: value
    });
  });
  return {
    id: referencedBobjectId,
    //url: referencedBobjectUrl,
    bobjectType: mainBobjectType,
    bobject: bobject,
    fields: translatedFields
  };
};
var getNameComponentFields = function getNameComponentFields(value, bobject) {
  var name;
  var bobjectType;
  var bobjectToOpen = bobject;
  if (value) {
    if ('logicRole' in value && value !== null && value !== void 0 && value.logicRole) {
      bobjectType = getBobjectFromLogicRole(value === null || value === void 0 ? void 0 : value.logicRole);
      name = value === null || value === void 0 ? void 0 : value.text;
    } else {
      var _bobjectToOpen, _bobjectToOpen$id;
      bobjectToOpen = value;
      bobjectType = (_bobjectToOpen = bobjectToOpen) === null || _bobjectToOpen === void 0 ? void 0 : (_bobjectToOpen$id = _bobjectToOpen.id) === null || _bobjectToOpen$id === void 0 ? void 0 : _bobjectToOpen$id.typeName;
      name = getTextFromLogicRole(bobjectToOpen, getNameFieldLRFromBobjectType(bobjectType));
    }
  }
  return {
    name: name,
    bobjectType: bobjectType,
    bobjectToOpen: bobjectToOpen
  };
};

var REGEX_REMOVE = /(<([^>]+)>)/gi;
var REGEX_ENTER = /(<\/?p>)|(<\/li>)|(<br>)/gi;
var REGEX_LIST = /(<li>)/gi;
var REGEX_MULTIPLE_SPACES = /  +/g;
var EMAIL_TYPE = {
  GMAIL: 'GMAIL',
  OUTLOOK: 'OUTLOOK',
  BLOOBIRDS: 'BLOOBIRDS'
};
var removeHtmlTags = function removeHtmlTags(text) {
  var _text$replace, _text$replace$replace, _text$replace$replace2;
  var styleRegexRemove = /<style[^>]*>[\s\S]*?<\/style>/gi;
  var xmlRegexRemove = /<xml[^>]*>[\s\S]*?<\/xml>/gi;
  var regexRemove = /<[^>]*>/gi;
  var specialCharactersRegexRemove = /&[^;]+;/g;
  return text === null || text === void 0 ? void 0 : (_text$replace = text.replace(styleRegexRemove, '')) === null || _text$replace === void 0 ? void 0 : (_text$replace$replace = _text$replace.replace(xmlRegexRemove, '')) === null || _text$replace$replace === void 0 ? void 0 : (_text$replace$replace2 = _text$replace$replace.replace(regexRemove, '')) === null || _text$replace$replace2 === void 0 ? void 0 : _text$replace$replace2.replace(specialCharactersRegexRemove, '');
};
var convertHtmlToString = function convertHtmlToString(body) {
  var _bodyParsed$replace, _bodyParsed$replace$r;
  var withNewLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var bodyWithVariables = isHtml(body) ? HTMLToString(body) : body;
  var bodyParsed = withNewLines ? bodyWithVariables === null || bodyWithVariables === void 0 ? void 0 : bodyWithVariables.replace(REGEX_ENTER, '\n') : bodyWithVariables;
  return bodyParsed === null || bodyParsed === void 0 ? void 0 : (_bodyParsed$replace = bodyParsed.replace(REGEX_LIST, '- ')) === null || _bodyParsed$replace === void 0 ? void 0 : (_bodyParsed$replace$r = _bodyParsed$replace.replace(REGEX_REMOVE, '')) === null || _bodyParsed$replace$r === void 0 ? void 0 : _bodyParsed$replace$r.replace(REGEX_MULTIPLE_SPACES, ' ');
};
var parseHtmlToEncodedString = function parseHtmlToEncodedString(body) {
  var withNewLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var plainText = convertHtmlToString(body, withNewLines);
  return encodeURIComponent(plainText.trim());
};
var PIXEL_REGEX = [/<[^>]+src\s*=\s*['"]*.*(mailtrack.io)([^'"]+)['"][^>]*>/g,
// mailtrack
/<[^>]+src="https:(\/\/nyl\.as|[^>]*.nylas.com).*[^>]*>/g,
// nylas
/<[^>]+href\s*=\s*['"]*.*(cirrusinsight.com)([^'"]+)['"][^>]*>/g,
// cirrus
/<img(?=\s)(?=[^>]*\bwidth\s*=\s*["']?1["']?)(?=[^>]*\bheight\s*=\s*["']?1["']?)(?![^>]*\bwidth\s*=\s*["']?[2-9]\d*["']?)(?![^>]*\bheight\s*=\s*["']?[2-9]\d*["']?)[^>]*>/g];
function parseEmailPixels(value) {
  var html = value;
  if (value) {
    html = PIXEL_REGEX.reduce(function (prev, regex) {
      return prev.replace(regex, '');
    }, value);
  }
  return html;
}
var createEmailLink = function createEmailLink(_ref) {
  var type = _ref.type,
    toEmail = _ref.toEmail,
    subject = _ref.subject,
    body = _ref.body;
  var parsedBody = parseHtmlToEncodedString(body || '', true);
  var parsedSubject = parseHtmlToEncodedString(subject || '', false);
  if (type === EMAIL_TYPE.GMAIL) {
    return "https://mail.google.com/mail/?view=cm&fs=1&to=".concat(encodeURIComponent(toEmail) || '', "&su=").concat(parsedSubject, "&body=").concat(parsedBody);
  }
  if (type === EMAIL_TYPE.OUTLOOK) {
    return "https://outlook.office.com/?path=/mail/action/compose&to=".concat(toEmail || '', "&subject=").concat(parsedSubject, "&body=").concat(parsedBody);
  }
  return "mailto:".concat(encodeURIComponent(toEmail) || '', "?subject=").concat(parsedSubject, "&body=").concat(parsedBody);
};
var EMAIL_MODE = Object.freeze({
  REPLY: 'REPLY',
  SEND: 'SEND'
});
var EmailModalType;
(function (EmailModalType) {
  EmailModalType["SEND"] = "SEND_NOW";
  EmailModalType["RETRY"] = "RETRY";
  EmailModalType["RESEND"] = "RESEND";
})(EmailModalType || (EmailModalType = {}));

function removeScrollOfBox() {
  var scrollableBox =
  //Salesforce selector
  document.querySelector('.viewport') ||
  //LinkedIn selector
  document.querySelector('.ember-application');
  if (scrollableBox) {
    var header = document.querySelector('#oneHeader');
    if (header) {
      header.setAttribute('style', 'padding-right: 6px; background-color: white;');
    }
    scrollableBox.setAttribute('style', 'overflow: hidden; margin-right: 6px;');
    var messageOverlay = document.querySelector('#msg-overlay');
    if (messageOverlay) {
      messageOverlay.setAttribute('style', 'right: 6px;');
    }
  }
}
function recoverScrollOfBox() {
  var scrollableBox =
  //Salesforce selector
  document.querySelector('.viewport') ||
  //LinkedIn selector
  document.querySelector('.ember-application');
  if (scrollableBox) {
    var header = document.querySelector('#oneHeader');
    if (header) {
      header.removeAttribute('style');
    }
    scrollableBox.removeAttribute('style');
    var messageOverlay = document.querySelector('#msg-overlay');
    if (messageOverlay) {
      messageOverlay.removeAttribute('style');
    }
  }
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime$1() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$1 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$2(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$1(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
if (typeof chrome !== 'undefined') {
  var _chrome$storage;
  (_chrome$storage = chrome.storage) === null || _chrome$storage === void 0 ? void 0 : _chrome$storage.sync.set({
    dataBackendUrl: 'https://bobject-api.bloobirds.com'
  });
}
var accountDataModel = function accountDataModel(_ref) {
  var dataModel = _ref.dataModel;
  return {
    getAccountId: function getAccountId() {
      return dataModel === null || dataModel === void 0 ? void 0 : dataModel.accountId;
    },
    getFieldsByBobjectType: function getFieldsByBobjectType(bobjectType) {
      var _dataModel$types;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types = dataModel.types) === null || _dataModel$types === void 0 ? void 0 : _dataModel$types.find(function (type) {
        return (type === null || type === void 0 ? void 0 : type.name) === bobjectType;
      });
    },
    findValueById: function findValueById(id) {
      var _dataModel$types2, _dataModel$types2$fla, _dataModel$types2$fla2;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types2 = dataModel.types) === null || _dataModel$types2 === void 0 ? void 0 : (_dataModel$types2$fla = _dataModel$types2.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types2$fla === void 0 ? void 0 : (_dataModel$types2$fla2 = _dataModel$types2$fla.flatMap(function (field) {
        return field === null || field === void 0 ? void 0 : field.values;
      })) === null || _dataModel$types2$fla2 === void 0 ? void 0 : _dataModel$types2$fla2.find(function (value) {
        return (value === null || value === void 0 ? void 0 : value.id) === id;
      });
    },
    findValueByLabel: function findValueByLabel(label) {
      var _dataModel$types3, _dataModel$types3$fla, _dataModel$types3$fla2;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types3 = dataModel.types) === null || _dataModel$types3 === void 0 ? void 0 : (_dataModel$types3$fla = _dataModel$types3.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types3$fla === void 0 ? void 0 : (_dataModel$types3$fla2 = _dataModel$types3$fla.flatMap(function (field) {
        return field === null || field === void 0 ? void 0 : field.values;
      })) === null || _dataModel$types3$fla2 === void 0 ? void 0 : _dataModel$types3$fla2.find(function (value) {
        return (value === null || value === void 0 ? void 0 : value.name) === label;
      });
    },
    findValueByLogicRole: function findValueByLogicRole(logicRole) {
      var _dataModel$types4, _dataModel$types4$fla, _dataModel$types4$fla2;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types4 = dataModel.types) === null || _dataModel$types4 === void 0 ? void 0 : (_dataModel$types4$fla = _dataModel$types4.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types4$fla === void 0 ? void 0 : (_dataModel$types4$fla2 = _dataModel$types4$fla.flatMap(function (field) {
        return field === null || field === void 0 ? void 0 : field.values;
      })) === null || _dataModel$types4$fla2 === void 0 ? void 0 : _dataModel$types4$fla2.find(function (value) {
        return (value === null || value === void 0 ? void 0 : value.id) === logicRole;
      });
    },
    findValuesByFieldId: function findValuesByFieldId(fieldId) {
      var _dataModel$types5, _dataModel$types5$fla, _dataModel$types5$fla2;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types5 = dataModel.types) === null || _dataModel$types5 === void 0 ? void 0 : (_dataModel$types5$fla = _dataModel$types5.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types5$fla === void 0 ? void 0 : (_dataModel$types5$fla2 = _dataModel$types5$fla.find(function (field) {
        return (field === null || field === void 0 ? void 0 : field.id) === fieldId;
      })) === null || _dataModel$types5$fla2 === void 0 ? void 0 : _dataModel$types5$fla2.values;
    },
    findValuesByFieldLogicRole: function findValuesByFieldLogicRole(fieldLogicRole) {
      var _dataModel$types6, _dataModel$types6$fla, _dataModel$types6$fla2;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types6 = dataModel.types) === null || _dataModel$types6 === void 0 ? void 0 : (_dataModel$types6$fla = _dataModel$types6.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types6$fla === void 0 ? void 0 : (_dataModel$types6$fla2 = _dataModel$types6$fla.find(function (field) {
        return (field === null || field === void 0 ? void 0 : field.logicRole) === fieldLogicRole;
      })) === null || _dataModel$types6$fla2 === void 0 ? void 0 : _dataModel$types6$fla2.values;
    },
    findFieldById: function findFieldById(id) {
      var _dataModel$types7, _dataModel$types7$fla;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types7 = dataModel.types) === null || _dataModel$types7 === void 0 ? void 0 : (_dataModel$types7$fla = _dataModel$types7.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types7$fla === void 0 ? void 0 : _dataModel$types7$fla.find(function (field) {
        return (field === null || field === void 0 ? void 0 : field.id) === id;
      });
    },
    findFieldByLogicRole: function findFieldByLogicRole(logicRole) {
      var _dataModel$types8, _dataModel$types8$fla;
      return dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$types8 = dataModel.types) === null || _dataModel$types8 === void 0 ? void 0 : (_dataModel$types8$fla = _dataModel$types8.flatMap(function (type) {
        return type === null || type === void 0 ? void 0 : type.fields;
      })) === null || _dataModel$types8$fla === void 0 ? void 0 : _dataModel$types8$fla.find(function (field) {
        return (field === null || field === void 0 ? void 0 : field.logicRole) === logicRole;
      });
    }
  };
};
function getDataModel() {
  return _getDataModel.apply(this, arguments);
}
function _getDataModel() {
  _getDataModel = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee() {
    var _yield$api$get, dataModel;
    return _regeneratorRuntime$1().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get('/utils/service/datamodel', {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: {}
            });
          case 3:
            _yield$api$get = _context.sent;
            dataModel = _yield$api$get.data;
            return _context.abrupt("return", accountDataModel({
              dataModel: dataModel
            }));
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _getDataModel.apply(this, arguments);
}
function getBuyerPersonas() {
  return _getBuyerPersonas.apply(this, arguments);
}
function _getBuyerPersonas() {
  _getBuyerPersonas = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee2() {
    var _yield$api$get2, data;
    return _regeneratorRuntime$1().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get('/utils/service/view/idealCustomerProfile', {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: {}
            });
          case 3:
            _yield$api$get2 = _context2.sent;
            data = _yield$api$get2.data;
            return _context2.abrupt("return", data);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", null);
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _getBuyerPersonas.apply(this, arguments);
}
function getTargetMarkets() {
  return _getTargetMarkets.apply(this, arguments);
}
function _getTargetMarkets() {
  _getTargetMarkets = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee3() {
    var _yield$api$get3, data;
    return _regeneratorRuntime$1().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get('/utils/service/view/targetMarket', {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: {}
            });
          case 3:
            _yield$api$get3 = _context3.sent;
            data = _yield$api$get3.data;
            return _context3.abrupt("return", data);
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", null);
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));
  return _getTargetMarkets.apply(this, arguments);
}
function searchUsers() {
  return _searchUsers.apply(this, arguments);
}
function _searchUsers() {
  _searchUsers = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee4() {
    var _yield$api$post, data;
    return _regeneratorRuntime$1().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post('/utils/service/users/search', {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: {
                active: true
              }
            });
          case 3:
            _yield$api$post = _context4.sent;
            data = _yield$api$post.data;
            return _context4.abrupt("return", data);
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", null);
          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return _searchUsers.apply(this, arguments);
}
function searchLead(_x) {
  return _searchLead.apply(this, arguments);
}
function _searchLead() {
  _searchLead = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee5(linkedInUrl) {
    var _yield$api$get4, data;
    return _regeneratorRuntime$1().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get('/linkedin/search/leads', {
              params: {
                linkedInUrl: linkedInUrl
              }
            });
          case 3:
            _yield$api$get4 = _context5.sent;
            data = _yield$api$get4.data;
            return _context5.abrupt("return", data);
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", null);
          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));
  return _searchLead.apply(this, arguments);
}
function searchLeadByQuery(_x2) {
  return _searchLeadByQuery.apply(this, arguments);
}
function _searchLeadByQuery() {
  _searchLeadByQuery = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee6(query) {
    var _yield$api$post2, data;
    return _regeneratorRuntime$1().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post('/linkedin/leads/query', _objectSpread$1({}, query));
          case 3:
            _yield$api$post2 = _context6.sent;
            data = _yield$api$post2.data;
            return _context6.abrupt("return", data);
          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", null);
          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));
  return _searchLeadByQuery.apply(this, arguments);
}
function searchCompaniesByQuery(_x3) {
  return _searchCompaniesByQuery.apply(this, arguments);
}
function _searchCompaniesByQuery() {
  _searchCompaniesByQuery = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee7(query) {
    var _yield$api$post3, data;
    return _regeneratorRuntime$1().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.post('/linkedin/companies/query', _objectSpread$1({}, query));
          case 3:
            _yield$api$post3 = _context7.sent;
            data = _yield$api$post3.data;
            return _context7.abrupt("return", data);
          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", null);
          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));
  return _searchCompaniesByQuery.apply(this, arguments);
}
function updateLeadSalesNavigatorUrl(_x4, _x5) {
  return _updateLeadSalesNavigatorUrl.apply(this, arguments);
}
function _updateLeadSalesNavigatorUrl() {
  _updateLeadSalesNavigatorUrl = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee8(bobjectId, salesNavigatorUrl) {
    return _regeneratorRuntime$1().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", api.put("/linkedin/leads/".concat(bobjectId.objectId, "/setSalesNavigatorUrl"), {
              salesNavigatorUrl: salesNavigatorUrl
            }));
          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _updateLeadSalesNavigatorUrl.apply(this, arguments);
}
function updateLeadLinkedInUrl(_x6, _x7) {
  return _updateLeadLinkedInUrl.apply(this, arguments);
}
function _updateLeadLinkedInUrl() {
  _updateLeadLinkedInUrl = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee9(bobjectId, linkedInUrl) {
    return _regeneratorRuntime$1().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", api.put("/linkedin/leads/".concat(bobjectId.objectId, "/setLinkedInUrl"), {
              linkedInUrl: linkedInUrl
            }));
          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _updateLeadLinkedInUrl.apply(this, arguments);
}
function updateLead(_x8, _x9, _x10) {
  return _updateLead.apply(this, arguments);
}
function _updateLead() {
  _updateLead = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee10(bobjectId, linkedInUrl, salesNavigatorURL) {
    return _regeneratorRuntime$1().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", api.put('/linkedin/leads/' + (bobjectId === null || bobjectId === void 0 ? void 0 : bobjectId.objectId), {
              salesNavigatorUrl: salesNavigatorURL || null,
              linkedInUrl: linkedInUrl || null
            }));
          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _updateLead.apply(this, arguments);
}

var ModalType;
(function (ModalType) {
  ModalType["PREVIEW_EMAIL"] = "previewEmail";
  ModalType["RETRY_EMAIL"] = "retryEmail";
  ModalType["SEND_NOW_EMAIL"] = "sendNowEmail";
  ModalType["RESCHEDULE_EMAIL"] = "rescheduleEmail";
  ModalType["CANCEL_EMAIL"] = "cancelEmail";
})(ModalType || (ModalType = {}));

function toHoursAndMinutes(totalMinutes) {
  var minutes = totalMinutes % 60;
  var hours = Math.floor(totalMinutes / 60);
  return "".concat(hours > 0 ? hours + 'hr ' : '').concat(minutes > 0 ? minutes + 'min' : '');
}
function parseCurrency(amount) {
  var _navigator;
  return new Intl.NumberFormat(((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language) || 'en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
var sliceObject = function sliceObject(object, start, end) {
  var objectKeys = Object.keys(object);
  var keys = objectKeys.splice(start, end);
  return keys.map(function (key) {
    return object[key];
  });
};
var mergeRemovingUndefined = function mergeRemovingUndefined() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  var undefinedKeys = values.flatMap(function (obj) {
    return Object.keys(obj).filter(function (key) {
      return isUndefined(obj[key]);
    });
  });
  return pickBy(assign.apply(void 0, [{}].concat(values)), function (value, key) {
    return !undefinedKeys.includes(key);
  });
};
var isObject = function isObject(obj) {
  return _typeof$1(obj) === 'object' && obj !== null && !Array.isArray(obj);
};
var isEmptyObject = function isEmptyObject() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).length === 0;
};
var isEqual = function isEqual(obj1, obj2) {
  if (isObject(obj1) && isObject(obj2)) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
  return false;
};
var mergeTwoObjectsRecursive = function mergeTwoObjectsRecursive(a, b) {
  var result = {};
  for (var _key2 in a) {
    if (isObject(a[_key2]) && isObject(b[_key2])) {
      result[_key2] = mergeTwoObjectsRecursive(a[_key2], b[_key2]);
    }
  }
  return _objectSpread(_objectSpread(_objectSpread({}, a), b), result);
};
var mergeTwoObjects = function mergeTwoObjects(a, b) {
  if (isObject(a) && isObject(b)) {
    return mergeTwoObjectsRecursive(a, b);
  } else if (isObject(a)) {
    return a;
  } else if (isObject(b)) {
    return b;
  } else return undefined;
};
var haveSameContentArrays = function haveSameContentArrays(a, b) {
  var sameOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (a === b) {
    return true;
  }
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  if (sameOrder) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
  } else {
    for (var _i = 0; _i < a.length; _i++) {
      if (!a.includes(b[_i]) || !b.includes(a[_i])) {
        return false;
      }
    }
  }
  return true;
};
function areListsEqual(list1, list2) {
  if (Array.isArray(list1) && Array.isArray(list2)) {
    if (list1.length === list2.length) {
      return list1.every(function (obj, index) {
        return isEqual(obj, list2[index]);
      });
    }
  }
  return false;
}
var partition = function partition(array, callback) {
  var matches = [];
  var nonMatches = [];
  array.forEach(function (element) {
    return (callback(element) ? matches : nonMatches).push(element);
  });
  return [matches, nonMatches];
};

/* eslint-disable no-unused-vars */

/*
  This is a SWR Utils used also in our app, any change here please propagate to our app
 */

// This is a SWR middleware for keeping the data even if key changes.
function keepPreviousResponse(useSWRNext) {
  return function (key, fetcher, config) {
    // Use a ref to store previous returned data.
    var laggyDataRef = useRef();

    // Actual SWR hook.
    var swr = useSWRNext(key, fetcher, config);
    useEffect(function () {
      // Update ref if data is not undefined.
      if (swr.data !== undefined) {
        laggyDataRef.current = swr.data;
      }
    }, [swr.data]);

    // Expose a method to clear the laggy data, if any.
    var resetLaggy = useCallback(function () {
      laggyDataRef.current = undefined;
    }, []);

    // Fallback to previous data if the current data is undefined.
    var dataOrLaggyData = swr.data === undefined ? laggyDataRef.current : swr.data;

    // Is it showing previous data?
    var isLagging = swr.data === undefined && laggyDataRef.current !== undefined;

    // Also add a `isLagging` field to SWR.
    return Object.assign({}, swr, {
      data: dataOrLaggyData,
      isLagging: isLagging,
      resetLaggy: resetLaggy
    });
  };
}

var openNewTab = function openNewTab(page, queryParams) {
  var url = "".concat(window.location.protocol, "//").concat(window.location.host).concat(page);
  var queryParamsParsed = queryParams && Object.keys(queryParams).map(function (key) {
    return "".concat(key, "=").concat(queryParams[key]);
  })[0];
  if (queryParamsParsed) {
    url = "".concat(url, "?").concat(queryParamsParsed);
  }
  window.open(url, '_blank');
};
var addHttpIfNeeded = function addHttpIfNeeded(url) {
  if (!/^https?:\/\//i.test(url)) {
    return "http://".concat(url);
  }
  return url;
};
var addHttpsIfNeeded = function addHttpsIfNeeded(url) {
  if (!/^https?:\/\//i.test(url)) {
    return "https://".concat(url);
  }
  return url;
};
var baseUrls = {
  production: 'https://app.bloobirds.com',
  development: 'https://app.dev-bloobirds.com',
  staging: 'https://app.staging-bloobirds.com'
};
function getLinkedinPathname(currentPage) {
  var match = currentPage === null || currentPage === void 0 ? void 0 : currentPage.split('linkedin.com');
  if (match && match.length > 1) {
    return match[1];
  } else {
    return '';
  }
}
function getSalesforcePathname(currentPage) {
  var match = currentPage.split('lightning.force.com');
  if (match && match.length > 1) {
    return match[1];
  } else {
    return '';
  }
}
function isLinkedInMessagesPage(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/messaging/');
}
function isSalesNavigatorMessagesPage(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/sales/inbox');
}
function isLinkedInProfilePage(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/in/');
}
function isLinkedInExamplePage(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/in/tonipereznavarro');
}
function isSalesNavigatorPage(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/sales');
}
function isSalesNavigatorProfile(currentPage) {
  return !!getLinkedinPathname(currentPage).match('^/sales/people/') || !!getLinkedinPathname(currentPage).match('^/sales/lead/');
}
function isSalesforcePage(currentPage) {
  return !!currentPage.match('^.*://.*.lightning.force.com.*');
}
function shouldInjectSalesforce(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  return !pathname.includes('/lightning/setup');
}
function isLinkedinOrSalesNav(currentPage) {
  return currentPage.includes('linkedin');
}
function isListOrSetupPage(path) {
  return !!path.match('/home') || !!path.match('/list') || !!path.match('/setup');
}
function isSalesforceLeadPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Lead') !== -1 && !isListOrSetupPage(pathname);
}
function isSalesforceTaskPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Task') !== -1 && !isListOrSetupPage(pathname);
}
function isSalesforceEventPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Event') !== -1 && !isListOrSetupPage(pathname);
}
function isSalesforceContactPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Contact') !== -1 && !isListOrSetupPage(pathname);
}
function isSalesforceAccountPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Account') !== -1 && !isListOrSetupPage(pathname);
}
function isSalesforceOpportunityPage(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  return pathSplit.indexOf('Opportunity') !== -1 && !isListOrSetupPage(pathname);
}
function isTaskOrEventSalesforcePage(currentPage) {
  return isSalesforceTaskPage(currentPage) || isSalesforceEventPage(currentPage);
}
function isLeadOrContactSalesforcePage(currentPage) {
  return isSalesforceLeadPage(currentPage) || isSalesforceContactPage(currentPage);
}
function getSalesforceIdFromPath(currentPage) {
  var pathname = getSalesforcePathname(currentPage);
  var pathSplit = pathname.split('/');
  var idIndex = pathSplit.indexOf(pathSplit === null || pathSplit === void 0 ? void 0 : pathSplit.find(function (v) {
    return ['Lead', 'Contact', 'Opportunity', 'Account', 'Task', 'Event'].includes(v);
  }));
  if (idIndex === -1) {
    return null;
  }
  return pathSplit[idIndex + 1];
}
function normalizeUrl(raw) {
  if (typeof raw === 'string') {
    var validRaw = raw === null || raw === void 0 ? void 0 : raw.replace('?bb-open', '');
    var validRaw2 = validRaw === null || validRaw === void 0 ? void 0 : validRaw.replace('?bb-messaging-tab-open', '');
    var url = normalize(validRaw2, {
      forceHttps: true,
      stripWWW: false,
      removeTrailingSlash: false,
      removeQueryParameters: true
    });
    if (isSalesNavigatorPage(url)) {
      var originalUrl = url.split(',')[0];
      // A ',' + suffix is needed for the URL to work
      return originalUrl + ',bb';
    }
    if (!url.endsWith('/')) {
      return url + '/';
    }
    return url;
  } else return null;
}
function createBloobirdsUrlByIdAndType(id, type) {
  var baseUrl = baseUrls["production"];
  if (type === BOBJECT_TYPES.LEAD) {
    return "".concat(baseUrl, "/app/cl/leads/").concat(id);
  }
  if (type === BOBJECT_TYPES.COMPANY) {
    return "".concat(baseUrl, "/app/cl/companies/").concat(id);
  }
  if (type === BOBJECT_TYPES.OPPORTUNITY) {
    return "".concat(baseUrl, "/app/cl/opportunities/").concat(id);
  }
  return baseUrl;
}
function createBloobirdsUrl(bobjectId) {
  return createBloobirdsUrlByIdAndType(bobjectId === null || bobjectId === void 0 ? void 0 : bobjectId.objectId, bobjectId === null || bobjectId === void 0 ? void 0 : bobjectId.typeName);
}
function redirectToLinkedInMessagingSettings() {
  var baseUrl = baseUrls["production"];
  return "".concat(baseUrl, "/app/playbook/messaging/linkedin");
}
function isIdLinkedinUrl(currentPage) {
  var _getLinkedinPathname$, _getLinkedinPathname$2;
  return isLinkedInProfilePage(currentPage) && ((_getLinkedinPathname$ = getLinkedinPathname(currentPage).match(/(?<=\/in\/).*(?=\/)/)) === null || _getLinkedinPathname$ === void 0 ? void 0 : (_getLinkedinPathname$2 = _getLinkedinPathname$[0]) === null || _getLinkedinPathname$2 === void 0 ? void 0 : _getLinkedinPathname$2.length) === 39;
}
function getLinedinIdFromUrl(currentPage) {
  var _getLinkedinPathname$3;
  return isIdLinkedinUrl(currentPage) ? (_getLinkedinPathname$3 = getLinkedinPathname(currentPage).match(/(?<=\/in\/).*(?=\/)/)) === null || _getLinkedinPathname$3 === void 0 ? void 0 : _getLinkedinPathname$3[0] : null;
}

var TEMPLATE_TYPES = Object.freeze({
  PITCH: 'PITCH',
  EMAIL: 'EMAIL',
  LINKEDIN_MESSAGE: 'LINKEDIN_MESSAGE',
  LINKEDIN: 'LINKEDIN_MESSAGE',
  QUALIFYING_QUESTION: 'QUALIFYING_QUESTION'
});
var QQ_TYPES = Object.freeze({
  GLOBAL_PICKLIST: 'GLOBAL_PICKLIST',
  MULTI_GLOBAL_PICKLIST: 'MULTI_GLOBAL_PICKLIST',
  TEXT: 'TEXT'
});
var QQ_TYPES_COPIES = Object.freeze({
  GLOBAL_PICKLIST: 'Picklist',
  MULTI_GLOBAL_PICKLIST: 'Multi Picklist',
  TEXT: 'Text'
});
var TEMPLATE_TYPES_COPIES = Object.freeze({
  PITCH: 'Pitch',
  EMAIL: 'Email',
  LINKEDIN_MESSAGE: 'Linkedin',
  LINKEDIN: 'Linkedin',
  QUALIFYING_QUESTION: 'qualifying question'
});
var TEMPLATE_TYPES_ICONS = Object.freeze({
  PITCH: 'alignLeft',
  EMAIL: 'mail',
  LINKEDIN_MESSAGE: 'linkedin',
  LINKEDIN: 'linkedin',
  QUALIFYING_QUESTION: 'chat'
});
var FORM_MODES = Object.freeze({
  EDITION: 'EDITION',
  CREATION: 'CREATION',
  CLONE: 'CLONE'
});
function generateTemplateURL(id, tabSelected, linkedInURL) {
  var baseUrl = baseUrls["production"];
  switch (tabSelected) {
    case PlaybookTab.PITCHES:
      return ["".concat(baseUrl, "/app/playbook/messaging/pitch/form?mode=EDITION&id=").concat(id)];
    case PlaybookTab.EMAILS:
      return ["".concat(baseUrl, "/app/playbook/messaging/email/form?mode=EDITION&id=").concat(id)];
    case PlaybookTab.LINKEDIN:
      return ["".concat(baseUrl, "/app/playbook/messaging/linkedin/form?mode=EDITION&id=").concat(id), linkedInURL];
    default:
      return [''];
  }
}
function getTemplateTypeButtons(template, tabSelected, linkedInURL, handleEmailModal) {
  var url = generateTemplateURL(template.id, tabSelected, linkedInURL);
  switch (tabSelected) {
    case PlaybookTab.PITCHES:
      return [{
        tooltipText: 'Edit in Bloobirds',
        buttonText: 'Edit',
        name: 'edit',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }];
    case PlaybookTab.EMAILS:
      return [{
        tooltipText: 'Edit in Bloobirds',
        name: 'edit',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }, {
        tooltipText: 'Send email',
        buttonText: 'Send',
        name: 'send',
        onClick: function onClick(e) {
          e.stopPropagation();
          handleEmailModal(template);
        }
      }];
    case PlaybookTab.LINKEDIN:
      return [{
        tooltipText: 'Edit in Bloobirds',
        name: 'edit',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }, {
        tooltipText: 'Open in LinkedIn',
        buttonText: 'Open in LinkedIn',
        name: 'linkedin',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[1]);
        }
      }];
    default:
      return [];
  }
}
function getLinkedInURL(id, company, leads, activeBobject) {
  var _activeBobject$id, _activeBobject$id2, _leads$, _leads$2, _leads$3, _leads$4, _activeBobject$id3;
  if ((activeBobject === null || activeBobject === void 0 ? void 0 : (_activeBobject$id = activeBobject.id) === null || _activeBobject$id === void 0 ? void 0 : _activeBobject$id.typeName) === BobjectTypes.Lead) {
    return activeBobject !== null && activeBobject !== void 0 && activeBobject.linkedInUrl ? (activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.linkedInUrl) + '?bb-messaging-tab-open&templateId=' + id : 'https://www.linkedin.com/messaging/thread/new/?bbFullName=' + (activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.fullName) + '&templateId=' + id + '&leadId=' + (activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.id) + company ? '&companyId=' + company : '';
  }
  if (!leads) return 'https://www.linkedin.com/messaging/thread/new/?bbFullName=undefined&templateId=' + id + '&leadId=undefined&companyId=' + (activeBobject === null || activeBobject === void 0 ? void 0 : (_activeBobject$id2 = activeBobject.id) === null || _activeBobject$id2 === void 0 ? void 0 : _activeBobject$id2.objectId);
  return (_leads$ = leads[0]) !== null && _leads$ !== void 0 && _leads$.linkedInUrl ? ((_leads$2 = leads[0]) === null || _leads$2 === void 0 ? void 0 : _leads$2.linkedInUrl) + '?bb-messaging-tab-open&templateId=' + id : 'https://www.linkedin.com/messaging/thread/new/?bbFullName=' + ((_leads$3 = leads[0]) === null || _leads$3 === void 0 ? void 0 : _leads$3.fullName) + '&templateId=' + id + '&leadId=' + ((_leads$4 = leads[0]) === null || _leads$4 === void 0 ? void 0 : _leads$4.id) + '&companyId=' + (activeBobject === null || activeBobject === void 0 ? void 0 : (_activeBobject$id3 = activeBobject.id) === null || _activeBobject$id3 === void 0 ? void 0 : _activeBobject$id3.objectId);
}

var segToTime = function segToTime(duration) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hh:mm:ss';
  if (!duration) {
    throw new Error('duration parameter is required');
  }
  if (duration > 86400) {
    throw new Error('duration should be less than one day');
  }
  var formatedTime;
  var seconds = Math.floor(duration % 60);
  var minutes = Math.floor(duration / 60 % 60);
  var hours = Math.floor(duration / (60 * 60) % 24);
  if (format === 'hh:mm:ss') {
    hours = hours < 10 && hours > 0 ? "0".concat(hours) : hours;
    minutes = minutes < 10 ? "0".concat(minutes) : minutes;
    seconds = seconds < 10 ? "0".concat(seconds) : seconds;
    formatedTime = hours > 0 ? "".concat(hours, ":").concat(minutes, ":").concat(seconds) : "".concat(minutes, ":").concat(seconds);
  } else if (format === 'hhh mmm sss') {
    var hoursText = hours > 0 ? "".concat(hours, "h") : '';
    var minutesText = minutes > 0 ? "".concat(minutes, "m") : '';
    var secondsText = seconds > 0 ? "".concat(seconds, "s") : '';
    if (hoursText) {
      formatedTime = hoursText;
    }
    if (formatedTime && minutesText) {
      formatedTime = "".concat(formatedTime, " ").concat(minutesText);
    } else if (minutesText) {
      formatedTime = minutesText;
    }
    if (formatedTime && secondsText) {
      formatedTime = "".concat(formatedTime, " ").concat(secondsText);
    } else if (secondsText) {
      formatedTime = secondsText;
    }
  }
  return formatedTime;
};

// colors with some colors remove to avoid some light colors to appear
var colors = {
  darkBloobirds: '#0077b5',
  bloobirds: '#1991ff',
  lightBloobirds: '#cde2f6',
  darkGray: '#484848',
  gray: '#b8b8b8',
  peanut: '#464f57',
  softPeanut: '#94a5ba',
  banana: '#ffbd19',
  softBanana: '#ffd166',
  melon: '#63ba00',
  softMelon: '#b4de85',
  grape: '#42da9c',
  softGrape: '#81ecc0',
  tangerine: '#ff8433',
  softTangerine: '#ffa366',
  seagreen: '#50ecac',
  tomato: '#f5245b',
  softTomato: '#ff6685',
  condition: '#8e8e8e',
  softCondition: '#b3b3b3',
  extraDarkBackground: '#606871',
  extraMeeting: '#F53158',
  extraCall: '#63BA00'
};
var randomizeColor = function randomizeColor() {
  var pantones = Object.values(colors);
  return pantones[Math.floor(Math.random() * Object.keys(colors).length)];
};
var randomizeColorName = function randomizeColorName() {
  var pantones = Object.keys(colors);
  return pantones[Math.floor(Math.random() * Object.keys(colors).length)];
};
var isSizeNumber = function isSizeNumber(size) {
  return size && !isNaN(size);
};

var isLeadPage = function isLeadPage(pathname) {
  var regex = /.+\/(?:leads(?=\/[0-9a-zA-Z]*)|companies(?=\/[0-9a-zA-Z]*\?leadId=[0-9a-zA-Z]*\/Lead\/[0-9a-zA-Z]*))/;
  return regex.test(pathname);
};
var isLeadWithoutCompanyPage = function isLeadWithoutCompanyPage(pathname) {
  var regex = /.+\/leads\/[0-9a-zA-Z]*/;
  return regex.test(pathname);
};
var isCompanyPage = function isCompanyPage(pathname) {
  var regex = /.+\/companies\/[0-9a-zA-Z]*/;
  return regex.test(pathname);
};
var isOpportunityPage = function isOpportunityPage(pathname) {
  var regex = /.+\/opportunities\/[0-9a-zA-Z]*/;
  return regex.test(pathname);
};
var isSalesPage = function isSalesPage(pathname) {
  var regex = /.+\/tasks\/sales*/;
  return regex.test(pathname);
};
var isProspectingPage = function isProspectingPage(pathname) {
  var regex = /.+\/tasks\/prospecting*/;
  return regex.test(pathname);
};
var isCompanyTasksPage = function isCompanyTasksPage(pathname) {
  var regex = /.+\/companies\/[a-zA-Z0-9]*\/tasks\/[a-zA-Z0-9]*/;
  return regex.test(pathname);
};
var isMatchingRoute = function isMatchingRoute(route, location) {
  var croppedRoute = route.lastIndexOf('/');
  var croppedLocation = location.lastIndexOf('/');
  if (isSalesPage(location) || isProspectingPage(location)) {
    return croppedRoute === croppedLocation;
  }
  return false;
};

var constructMixpanelCustomRoute = function constructMixpanelCustomRoute(path) {
  if (isLeadPage(path)) {
    return 'LEAD_PAGE';
  }
  if (isCompanyPage(path)) {
    return 'COMPANY_PAGE';
  }
  if (isLeadWithoutCompanyPage(path)) {
    return 'LEAD_WITHOUT_COMPANY_PAGE';
  }
  if (isOpportunityPage(path)) {
    return 'OPP_PAGE';
  }
  return path;
};

// TODO: Add provider as how we were doing it before was not working
var fetchAndOpenNylasUrl = function fetchAndOpenNylasUrl() {
  api.get('/utils/nylas/generate-url').then(function (payload) {
    window.open(payload.data.url);
  });
};
var fetchAndOpenLegacyUrl = function fetchAndOpenLegacyUrl() {
  api.get('/utils/service/gmail/connections/endpoint').then(function (payload) {
    window.open(payload.data.endpoint);
  });
};

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function getSalesforceSobject(_x, _x2) {
  return _getSalesforceSobject.apply(this, arguments);
}
function _getSalesforceSobject() {
  _getSalesforceSobject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sobjectType, id) {
    var _yield$api$get, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/utils/service/salesforce/sobject/".concat(sobjectType, "/").concat(id));
          case 3:
            _yield$api$get = _context.sent;
            data = _yield$api$get.data;
            return _context.abrupt("return", data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", null);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _getSalesforceSobject.apply(this, arguments);
}
function getSalesforceListDefinition(_x3, _x4) {
  return _getSalesforceListDefinition.apply(this, arguments);
}
function _getSalesforceListDefinition() {
  _getSalesforceListDefinition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sobjectType, id) {
    var _yield$api$get2, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get("/utils/service/salesforce/total/".concat(sobjectType, "/").concat(id));
          case 3:
            _yield$api$get2 = _context2.sent;
            data = _yield$api$get2.data;
            return _context2.abrupt("return", data);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            return _context2.abrupt("return", null);
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _getSalesforceListDefinition.apply(this, arguments);
}
function querySalesforce(_x5) {
  return _querySalesforce.apply(this, arguments);
}
function _querySalesforce() {
  _querySalesforce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(query) {
    var _yield$api$post, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.post("/utils/service/salesforce/query", {
              query: query
            });
          case 3:
            _yield$api$post = _context3.sent;
            data = _yield$api$post.data;
            return _context3.abrupt("return", data);
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            return _context3.abrupt("return", null);
          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));
  return _querySalesforce.apply(this, arguments);
}
function createBobjectInSfdc(_x6, _x7) {
  return _createBobjectInSfdc.apply(this, arguments);
}
function _createBobjectInSfdc() {
  _createBobjectInSfdc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(composedBobjectId, createContact) {
    var _yield$api$post2, data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post("/utils/service/salesforce/sync/".concat(composedBobjectId).concat(createContact ? '?createContact=true' : ''), {});
          case 3:
            _yield$api$post2 = _context4.sent;
            data = _yield$api$post2.data;
            return _context4.abrupt("return", data);
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0);
            throw new Error();
          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return _createBobjectInSfdc.apply(this, arguments);
}
function getSobjectTypeFromId(sobjectId) {
  var startingSobjectId = sobjectId === null || sobjectId === void 0 ? void 0 : sobjectId.slice(0, 3);
  switch (startingSobjectId) {
    case '001':
      return 'Account';
    case '003':
      return 'Contact';
    case '00Q':
      return 'Lead';
    case '006':
      return 'Opportunity';
    default:
      return 'Other';
  }
}

export { EMAIL_MODE, EMAIL_TYPE, EmailModalType, FORM_MODES, HTMLToString, ModalType, QQ_TYPES, QQ_TYPES_COPIES, TEMPLATE_TYPES, TEMPLATE_TYPES_COPIES, TEMPLATE_TYPES_ICONS, add, addHoursToStringDate, addHttpIfNeeded, addHttpsIfNeeded, addMinutes, addMonth, addTaskDateGrouping, api, appHostnames, areListsEqual, baseUrls, bobjectPlurals, canBeMarkedAsDone, checkIsSalesBobject, colors, commaAndFormatArray, companyUrl, constructMixpanelCustomRoute, convertHtmlToString, convertLeadInBloobirds, convertLocationToHourMinutes, createBloobirdsUrl, createBloobirdsUrlByIdAndType, createBobjectInSfdc, createEmailLink, ellipsis, fetchAndOpenLegacyUrl, fetchAndOpenNylasUrl, firstWeekOfNextMonth, formatDate, formatDateAsText, formatDistance, formatDistanceToNow, formatSecondToElapsedTime, generateBobjectBasedData, generateDatePrefix, generateShortName, getAccountId, getBobjectFromLogicRole, getBobjectTypeFromPathname, getButtonMarkAsDone, getBuyerPersonas, getCurrentTime, getCurrentTimeBeautiful, getCurrentTimeSimple, getDataModel, getDateFormatted, getDateRange, getDateTimestampString, getDayAndWeekNumberFromDate, getDayOfWeekStartingFromMonday, getDifferenceInMinutes, getExtensionBobjectByIdFields, getFieldById, getFieldByLogicRole, getFieldTextById, getFieldsByIds, getFieldsByType, getISODate, getISOShortFormattedDate, getIsSales, getLeadById, getLinedinIdFromUrl, getLinkedInURL, getLocationFromCompleteTimeZone, getNameComponentFields, getNameFieldLRFromBobjectType, getOpportunityById, getPluralBobjectName, getRangeBetweenDates, getReferencedBobject, getReferencedBobjectFromLogicRole, getRelatedBobject, getRelatedBobjectTypeName, getRoundedDateTime, getSalesforceIdFromPath, getSalesforceListDefinition, getSalesforceSobject, getSimpleDate, getSobjectTypeFromId, getTargetMarkets, getTaskLocalTime, getTaskReferenceBobject, getTaskType, getTemplateTypeButtons, getTextFromLogicRole, getToken, getTokenEncoded, getUTCDate, getUTCFromCompleteTimeZone, getUserId, getUserName, getUserTimeZone, getValueFromLogicRole, getWeeksInMonth, hasRequiredMissing, haveSameContentArrays, indefiniteArticle, injectReferencesSearchProcess, intervalDaysOfMonth, isActivity, isAfterDate, isAfterToday, isAfterTomorrow, isAutomatedEmailTask, isBeforeToday, isCadenceTask, isCallTask, isCompany, isCompanyPage, isCompanyTasksPage, isDifferentYearThanCurrent, isEmail, isEmailTask, isEmptyObject, isEqual, isHtml, isIdLinkedinUrl, isLead, isLeadOrContactSalesforcePage, isLeadPage, isLeadWithoutCompanyPage, isLinkedInExamplePage, isLinkedInMessagesPage, isLinkedInProfilePage, isLinkedinMessageTask, isLinkedinOrSalesNav, isListOrSetupPage, isLoggedIn, isMatchingRoute, isMeetingTypeTask, isObject, isOpportunity, isOpportunityPage, isProspectingPage, isSalesNavigatorMessagesPage, isSalesNavigatorPage, isSalesNavigatorProfile, isSalesPage, isSalesforceAccountPage, isSalesforceContactPage, isSalesforceEventPage, isSalesforceLeadPage, isSalesforceOpportunityPage, isSalesforcePage, isSalesforceTaskPage, isSameDayDate, isScheduledTask, isSizeNumber, isTask, isTaskOrEventSalesforcePage, isToday, isTomorrow, isUrl, isWeekend, keepPreviousResponse, lastWeekOfPrevMonth, leadUrl, linkify, login, logout, mergeRemovingUndefined, mergeTwoObjects, normalizeUrl, numberToOrdinalString, numberWithDots, openNewTab, parseAmount, parseCurrency, parseEmailPixels, parseTimeToDatetime, parseUTCDateTimeToLocal, parseUTCDateToLocal, partition, privateTimeZoneFunctions, querySalesforce, randomizeColor, randomizeColorName, recoverScrollOfBox, redirectToLinkedInMessagingSettings, removeHtmlTags, removeScrollOfBox, replaceVariables, searchCompaniesByQuery, searchLead, searchLeadByQuery, searchUsers, segToTime, shortenAmount, shouldInjectSalesforce, sliceObject, stringToHTML, subMinutes, subMonth, tabBobjectType, toCamelCase, toCamelCaseUpperFirst, toHoursAndMinutes, toSentenceCase, toTitleCase, today, transformCalendarEventDate, updateLead, updateLeadLinkedInUrl, updateLeadSalesNavigatorUrl };
